import { baseApi as api } from './BaseApi.service';
export const addTagTypes = [
  'auth',
  'verify',
  'logout',
  'twitter',
  'google',
  'github',
  'telegram',
  'discord',
  'steam',
  'reddit',
  'spotify',
  'apple',
  'verification',
  'accounts',
  'users',
  'profile',
  'file',
  'notification',
  'leaderboard',
  'clan',
  'customer',
  'home',
  'taskSettings',
  'invalidate-task',
  'invalidate-giveaway',
  'task',
  'giveaway',
  'Rewards',
  'statistics',
  'MidleTasks',
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      appControllerGetTest: build.query<
        AppControllerGetTestApiResponse,
        AppControllerGetTestApiArg
      >({
        query: () => ({ url: '/' }),
      }),
      appControllerGetTime2: build.query<
        AppControllerGetTime2ApiResponse,
        AppControllerGetTime2ApiArg
      >({
        query: () => ({ url: '/version/time-0' }),
      }),
      appControllerGetTime1: build.query<
        AppControllerGetTime1ApiResponse,
        AppControllerGetTime1ApiArg
      >({
        query: () => ({ url: '/version/time-1' }),
      }),
      appControllerGetTime3: build.query<
        AppControllerGetTime3ApiResponse,
        AppControllerGetTime3ApiArg
      >({
        query: () => ({ url: '/version/time-2' }),
      }),
      appControllerGetVersion: build.query<
        AppControllerGetVersionApiResponse,
        AppControllerGetVersionApiArg
      >({
        query: () => ({ url: '/version' }),
      }),
      authControllerRemove: build.mutation<
        AuthControllerRemoveApiResponse,
        AuthControllerRemoveApiArg
      >({
        query: () => ({ url: '/auth', method: 'DELETE' }),
        invalidatesTags: ['auth'],
      }),
      authControllerRegister: build.mutation<
        AuthControllerRegisterApiResponse,
        AuthControllerRegisterApiArg
      >({
        query: (queryArg) => ({ url: '/auth/register', method: 'POST', body: queryArg }),
        invalidatesTags: ['auth'],
      }),
      authControllerLogin: build.mutation<
        AuthControllerLoginApiResponse,
        AuthControllerLoginApiArg
      >({
        query: (queryArg) => ({ url: '/auth/login', method: 'POST', body: queryArg }),
        invalidatesTags: ['auth'],
      }),
      authControllerRefresh: build.mutation<
        AuthControllerRefreshApiResponse,
        AuthControllerRefreshApiArg
      >({
        query: () => ({ url: '/auth/refresh', method: 'POST' }),
        invalidatesTags: ['auth'],
      }),
      authControllerUnVerifiedAccounts: build.query<
        AuthControllerUnVerifiedAccountsApiResponse,
        AuthControllerUnVerifiedAccountsApiArg
      >({
        query: () => ({ url: '/auth/verify' }),
        providesTags: ['auth'],
      }),
      authControllerVerify: build.mutation<
        AuthControllerVerifyApiResponse,
        AuthControllerVerifyApiArg
      >({
        query: () => ({ url: '/auth/verify', method: 'POST' }),
        invalidatesTags: ['auth', 'verify'],
      }),
      authControllerRecovery: build.mutation<
        AuthControllerRecoveryApiResponse,
        AuthControllerRecoveryApiArg
      >({
        query: (queryArg) => ({ url: '/auth/recovery', method: 'POST', body: queryArg }),
        invalidatesTags: ['auth'],
      }),
      authControllerReset: build.mutation<
        AuthControllerResetApiResponse,
        AuthControllerResetApiArg
      >({
        query: (queryArg) => ({ url: '/auth/reset', method: 'POST', body: queryArg }),
        invalidatesTags: ['auth'],
      }),
      authControllerLogout: build.mutation<
        AuthControllerLogoutApiResponse,
        AuthControllerLogoutApiArg
      >({
        query: () => ({ url: '/auth/logout', method: 'POST' }),
        invalidatesTags: ['auth', 'logout'],
      }),
      authControllerChangePassword: build.mutation<
        AuthControllerChangePasswordApiResponse,
        AuthControllerChangePasswordApiArg
      >({
        query: (queryArg) => ({ url: '/auth/change-password', method: 'PATCH', body: queryArg }),
        invalidatesTags: ['auth'],
      }),
      authControllerSetUsername: build.mutation<
        AuthControllerSetUsernameApiResponse,
        AuthControllerSetUsernameApiArg
      >({
        query: (queryArg) => ({ url: '/auth/username', method: 'PATCH', body: queryArg }),
        invalidatesTags: ['auth'],
      }),
      authControllerClaim: build.mutation<
        AuthControllerClaimApiResponse,
        AuthControllerClaimApiArg
      >({
        query: (queryArg) => ({ url: '/auth/claim', method: 'POST', body: queryArg }),
        invalidatesTags: ['auth'],
      }),
      walletControllerAuthenticate: build.mutation<
        WalletControllerAuthenticateApiResponse,
        WalletControllerAuthenticateApiArg
      >({
        query: (queryArg) => ({ url: '/auth/wallet', method: 'POST', body: queryArg }),
        invalidatesTags: ['auth'],
      }),
      walletControllerGetMetamaskLoginMessage: build.query<
        WalletControllerGetMetamaskLoginMessageApiResponse,
        WalletControllerGetMetamaskLoginMessageApiArg
      >({
        query: (queryArg) => ({
          url: '/auth/wallet/metamaskloginmessage',
          params: { wallet: queryArg },
        }),
        providesTags: ['auth'],
      }),
      walletControllerDisconnectWallet: build.mutation<
        WalletControllerDisconnectWalletApiResponse,
        WalletControllerDisconnectWalletApiArg
      >({
        query: (queryArg) => ({ url: '/auth/wallet/disconnect', method: 'POST', body: queryArg }),
        invalidatesTags: ['auth'],
      }),
      walletControllerConnectWallet: build.mutation<
        WalletControllerConnectWalletApiResponse,
        WalletControllerConnectWalletApiArg
      >({
        query: (queryArg) => ({ url: '/auth/wallet/connect', method: 'POST', body: queryArg }),
        invalidatesTags: ['auth'],
      }),
      twitterControllerGetAuthorizeUrl: build.query<
        TwitterControllerGetAuthorizeUrlApiResponse,
        TwitterControllerGetAuthorizeUrlApiArg
      >({
        query: () => ({ url: '/auth/twitter/authorize-url' }),
        providesTags: ['twitter'],
      }),
      twitterControllerAuthenticate: build.mutation<
        TwitterControllerAuthenticateApiResponse,
        TwitterControllerAuthenticateApiArg
      >({
        query: (queryArg) => ({ url: '/auth/twitter', method: 'POST', body: queryArg }),
        invalidatesTags: ['twitter'],
      }),
      twitterControllerConnect: build.mutation<
        TwitterControllerConnectApiResponse,
        TwitterControllerConnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/twitter/connect', method: 'POST', body: queryArg }),
        invalidatesTags: ['twitter'],
      }),
      twitterControllerDisconnect: build.mutation<
        TwitterControllerDisconnectApiResponse,
        TwitterControllerDisconnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/twitter/disconnect', method: 'POST', body: queryArg }),
        invalidatesTags: ['twitter'],
      }),
      googleControllerAuthenticate: build.mutation<
        GoogleControllerAuthenticateApiResponse,
        GoogleControllerAuthenticateApiArg
      >({
        query: (queryArg) => ({ url: '/auth/google', method: 'POST', body: queryArg }),
        invalidatesTags: ['google'],
      }),
      googleControllerGetAuthorizeUrl: build.query<
        GoogleControllerGetAuthorizeUrlApiResponse,
        GoogleControllerGetAuthorizeUrlApiArg
      >({
        query: () => ({ url: '/auth/google/authorize-url' }),
        providesTags: ['google'],
      }),
      googleControllerConnect: build.mutation<
        GoogleControllerConnectApiResponse,
        GoogleControllerConnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/google/connect', method: 'POST', body: queryArg }),
        invalidatesTags: ['google'],
      }),
      googleControllerDisconnect: build.mutation<
        GoogleControllerDisconnectApiResponse,
        GoogleControllerDisconnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/google/disconnect', method: 'POST', body: queryArg }),
        invalidatesTags: ['google'],
      }),
      githubControllerAuthenticate: build.mutation<
        GithubControllerAuthenticateApiResponse,
        GithubControllerAuthenticateApiArg
      >({
        query: (queryArg) => ({ url: '/auth/github', method: 'POST', body: queryArg }),
        invalidatesTags: ['github'],
      }),
      githubControllerGetAuthorizeUrl: build.query<
        GithubControllerGetAuthorizeUrlApiResponse,
        GithubControllerGetAuthorizeUrlApiArg
      >({
        query: () => ({ url: '/auth/github/authorize-url' }),
        providesTags: ['github'],
      }),
      githubControllerConnect: build.mutation<
        GithubControllerConnectApiResponse,
        GithubControllerConnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/github/connect', method: 'POST', body: queryArg }),
        invalidatesTags: ['github'],
      }),
      githubControllerDisconnect: build.mutation<
        GithubControllerDisconnectApiResponse,
        GithubControllerDisconnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/github/disconnect', method: 'POST', body: queryArg }),
        invalidatesTags: ['github'],
      }),
      telegramControllerAuthenticate: build.mutation<
        TelegramControllerAuthenticateApiResponse,
        TelegramControllerAuthenticateApiArg
      >({
        query: (queryArg) => ({ url: '/auth/telegram', method: 'POST', body: queryArg }),
        invalidatesTags: ['telegram'],
      }),
      telegramControllerConnect: build.mutation<
        TelegramControllerConnectApiResponse,
        TelegramControllerConnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/telegram/connect', method: 'POST', body: queryArg }),
        invalidatesTags: ['telegram'],
      }),
      telegramControllerDisconnect: build.mutation<
        TelegramControllerDisconnectApiResponse,
        TelegramControllerDisconnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/telegram/disconnect', method: 'POST', body: queryArg }),
        invalidatesTags: ['telegram'],
      }),
      discordControllerAuthenticate: build.mutation<
        DiscordControllerAuthenticateApiResponse,
        DiscordControllerAuthenticateApiArg
      >({
        query: (queryArg) => ({ url: '/auth/discord', method: 'POST', body: queryArg }),
        invalidatesTags: ['discord'],
      }),
      discordControllerGetAuthorizeUrl: build.query<
        DiscordControllerGetAuthorizeUrlApiResponse,
        DiscordControllerGetAuthorizeUrlApiArg
      >({
        query: () => ({ url: '/auth/discord/authorize-url' }),
        providesTags: ['discord'],
      }),
      discordControllerConnect: build.mutation<
        DiscordControllerConnectApiResponse,
        DiscordControllerConnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/discord/connect', method: 'POST', body: queryArg }),
        invalidatesTags: ['discord'],
      }),
      discordControllerDisconnect: build.mutation<
        DiscordControllerDisconnectApiResponse,
        DiscordControllerDisconnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/discord/disconnect', method: 'POST', body: queryArg }),
        invalidatesTags: ['discord'],
      }),
      steamControllerAuthenticate: build.mutation<
        SteamControllerAuthenticateApiResponse,
        SteamControllerAuthenticateApiArg
      >({
        query: (queryArg) => ({ url: '/auth/steam', method: 'POST', body: queryArg }),
        invalidatesTags: ['steam'],
      }),
      steamControllerGetAuthorizeUrl: build.query<
        SteamControllerGetAuthorizeUrlApiResponse,
        SteamControllerGetAuthorizeUrlApiArg
      >({
        query: () => ({ url: '/auth/steam/authorize-url' }),
        providesTags: ['steam'],
      }),
      steamControllerConnect: build.mutation<
        SteamControllerConnectApiResponse,
        SteamControllerConnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/steam/connect', method: 'POST', body: queryArg }),
        invalidatesTags: ['steam'],
      }),
      steamControllerDisconnect: build.mutation<
        SteamControllerDisconnectApiResponse,
        SteamControllerDisconnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/steam/disconnect', method: 'POST', body: queryArg }),
        invalidatesTags: ['steam'],
      }),
      redditControllerAuthenticate: build.mutation<
        RedditControllerAuthenticateApiResponse,
        RedditControllerAuthenticateApiArg
      >({
        query: (queryArg) => ({ url: '/auth/reddit', method: 'POST', body: queryArg }),
        invalidatesTags: ['reddit'],
      }),
      redditControllerGetAuthorizeUrl: build.query<
        RedditControllerGetAuthorizeUrlApiResponse,
        RedditControllerGetAuthorizeUrlApiArg
      >({
        query: () => ({ url: '/auth/reddit/authorize-url' }),
        providesTags: ['reddit'],
      }),
      redditControllerConnect: build.mutation<
        RedditControllerConnectApiResponse,
        RedditControllerConnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/reddit/connect', method: 'POST', body: queryArg }),
        invalidatesTags: ['reddit'],
      }),
      redditControllerDisconnect: build.mutation<
        RedditControllerDisconnectApiResponse,
        RedditControllerDisconnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/reddit/disconnect', method: 'POST', body: queryArg }),
        invalidatesTags: ['reddit'],
      }),
      spotifyControllerAuthenticate: build.mutation<
        SpotifyControllerAuthenticateApiResponse,
        SpotifyControllerAuthenticateApiArg
      >({
        query: (queryArg) => ({ url: '/auth/spotify', method: 'POST', body: queryArg }),
        invalidatesTags: ['spotify'],
      }),
      spotifyControllerGetAuthorizeUrl: build.query<
        SpotifyControllerGetAuthorizeUrlApiResponse,
        SpotifyControllerGetAuthorizeUrlApiArg
      >({
        query: () => ({ url: '/auth/spotify/authorize-url' }),
        providesTags: ['spotify'],
      }),
      spotifyControllerConnect: build.mutation<
        SpotifyControllerConnectApiResponse,
        SpotifyControllerConnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/spotify/connect', method: 'POST', body: queryArg }),
        invalidatesTags: ['spotify'],
      }),
      spotifyControllerDisconnect: build.mutation<
        SpotifyControllerDisconnectApiResponse,
        SpotifyControllerDisconnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/spotify/disconnect', method: 'POST', body: queryArg }),
        invalidatesTags: ['spotify'],
      }),
      appleControllerAuthenticate: build.mutation<
        AppleControllerAuthenticateApiResponse,
        AppleControllerAuthenticateApiArg
      >({
        query: (queryArg) => ({ url: '/auth/apple', method: 'POST', body: queryArg }),
        invalidatesTags: ['apple'],
      }),
      appleControllerConnect: build.mutation<
        AppleControllerConnectApiResponse,
        AppleControllerConnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/apple/connect', method: 'POST', body: queryArg }),
        invalidatesTags: ['apple'],
      }),
      appleControllerDisconnect: build.mutation<
        AppleControllerDisconnectApiResponse,
        AppleControllerDisconnectApiArg
      >({
        query: (queryArg) => ({ url: '/auth/apple/disconnect', method: 'POST', body: queryArg }),
        invalidatesTags: ['apple'],
      }),
      cosmosControllerAuthenticate: build.mutation<
        CosmosControllerAuthenticateApiResponse,
        CosmosControllerAuthenticateApiArg
      >({
        query: (queryArg) => ({ url: '/auth/cosmos', method: 'POST', body: queryArg }),
        invalidatesTags: ['auth'],
      }),
      cosmosControllerGetCosmosLoginMessage: build.query<
        CosmosControllerGetCosmosLoginMessageApiResponse,
        CosmosControllerGetCosmosLoginMessageApiArg
      >({
        query: (queryArg) => ({ url: '/auth/cosmos/loginmessage', params: { wallet: queryArg } }),
        providesTags: ['auth'],
      }),
      cosmosControllerDisconnectCosmos: build.mutation<
        CosmosControllerDisconnectCosmosApiResponse,
        CosmosControllerDisconnectCosmosApiArg
      >({
        query: (queryArg) => ({ url: '/auth/cosmos/disconnect', method: 'POST', body: queryArg }),
        invalidatesTags: ['auth'],
      }),
      cosmosControllerConnectWallet: build.mutation<
        CosmosControllerConnectWalletApiResponse,
        CosmosControllerConnectWalletApiArg
      >({
        query: (queryArg) => ({ url: '/auth/cosmos/connect', method: 'POST', body: queryArg }),
        invalidatesTags: ['auth'],
      }),
      verificationControllerVerify: build.mutation<
        VerificationControllerVerifyApiResponse,
        VerificationControllerVerifyApiArg
      >({
        query: (queryArg) => ({ url: '/auth/verification', method: 'POST', body: queryArg }),
        invalidatesTags: ['verification'],
      }),
      verificationControllerResend: build.mutation<
        VerificationControllerResendApiResponse,
        VerificationControllerResendApiArg
      >({
        query: (queryArg) => ({ url: '/auth/verification/resend', method: 'POST', body: queryArg }),
        invalidatesTags: ['verification'],
      }),
      accountsControllerAdd: build.mutation<
        AccountsControllerAddApiResponse,
        AccountsControllerAddApiArg
      >({
        query: (queryArg) => ({ url: '/users/accounts', method: 'POST', body: queryArg }),
        invalidatesTags: ['accounts'],
      }),
      accountsControllerFind: build.query<
        AccountsControllerFindApiResponse,
        AccountsControllerFindApiArg
      >({
        query: (queryArg) => ({
          url: '/users/accounts',
          params: {
            provider: queryArg.provider,
            identity: queryArg.identity,
            isVerified: queryArg.isVerified,
            username: queryArg.username,
          },
        }),
        providesTags: ['accounts'],
      }),
      accountsControllerUpdate: build.mutation<
        AccountsControllerUpdateApiResponse,
        AccountsControllerUpdateApiArg
      >({
        query: (queryArg) => ({ url: '/users/accounts', method: 'PATCH', body: queryArg }),
        invalidatesTags: ['accounts'],
      }),
      accountsControllerRemove: build.mutation<
        AccountsControllerRemoveApiResponse,
        AccountsControllerRemoveApiArg
      >({
        query: (queryArg) => ({ url: '/users/accounts', method: 'DELETE', body: queryArg }),
        invalidatesTags: ['accounts'],
      }),
      accountsControllerAddEmail: build.mutation<
        AccountsControllerAddEmailApiResponse,
        AccountsControllerAddEmailApiArg
      >({
        query: (queryArg) => ({ url: '/users/accounts/email', method: 'POST', body: queryArg }),
        invalidatesTags: ['accounts'],
      }),
      accountsControllerGetAccounts: build.query<
        AccountsControllerGetAccountsApiResponse,
        AccountsControllerGetAccountsApiArg
      >({
        query: (queryArg) => ({ url: `/users/accounts/provider/${queryArg}` }),
        providesTags: ['accounts', 'verify'],
      }),
      accountsControllerVerifyAccount: build.mutation<
        AccountsControllerVerifyAccountApiResponse,
        AccountsControllerVerifyAccountApiArg
      >({
        query: (queryArg) => ({ url: '/users/accounts/verify', method: 'PATCH', body: queryArg }),
        invalidatesTags: ['accounts'],
      }),
      accountsControllerSetPrimary: build.mutation<
        AccountsControllerSetPrimaryApiResponse,
        AccountsControllerSetPrimaryApiArg
      >({
        query: (queryArg) => ({
          url: '/users/accounts/set-primary',
          method: 'PATCH',
          body: queryArg,
        }),
        invalidatesTags: ['accounts'],
      }),
      usersControllerCreate: build.mutation<
        UsersControllerCreateApiResponse,
        UsersControllerCreateApiArg
      >({
        query: (queryArg) => ({ url: '/users', method: 'POST', body: queryArg }),
        invalidatesTags: ['users'],
      }),
      usersControllerUpdate: build.mutation<
        UsersControllerUpdateApiResponse,
        UsersControllerUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/users/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateUserDto,
        }),
        invalidatesTags: ['users'],
      }),
      usersControllerRemove: build.mutation<
        UsersControllerRemoveApiResponse,
        UsersControllerRemoveApiArg
      >({
        query: (queryArg) => ({ url: `/users/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['users'],
      }),
      usersControllerRoleChange: build.mutation<
        UsersControllerRoleChangeApiResponse,
        UsersControllerRoleChangeApiArg
      >({
        query: (queryArg) => ({
          url: `/users/change-role/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateRolesDto,
        }),
        invalidatesTags: ['users'],
      }),
      usersControllerChangePassword: build.mutation<
        UsersControllerChangePasswordApiResponse,
        UsersControllerChangePasswordApiArg
      >({
        query: (queryArg) => ({
          url: `/users/${queryArg.id}/change-password`,
          method: 'PATCH',
          body: queryArg.updatePasswordDto,
        }),
        invalidatesTags: ['users'],
      }),
      profileControllerGetUserAvatar: build.query<
        ProfileControllerGetUserAvatarApiResponse,
        ProfileControllerGetUserAvatarApiArg
      >({
        query: () => ({ url: '/profile/avatar' }),
        providesTags: ['profile'],
      }),
      profileControllerUploadUserAvatar: build.mutation<
        ProfileControllerUploadUserAvatarApiResponse,
        ProfileControllerUploadUserAvatarApiArg
      >({
        query: (queryArg) => ({ url: '/profile/avatar', method: 'POST', body: queryArg }),
        invalidatesTags: ['profile'],
      }),
      profileControllerGetUserDetailsWithCustomer: build.query<
        ProfileControllerGetUserDetailsWithCustomerApiResponse,
        ProfileControllerGetUserDetailsWithCustomerApiArg
      >({
        query: (queryArg) => ({ url: `/profile/${queryArg}/customer` }),
        providesTags: ['profile'],
      }),
      profileControllerGetUserDetailsWithAdmin: build.query<
        ProfileControllerGetUserDetailsWithAdminApiResponse,
        ProfileControllerGetUserDetailsWithAdminApiArg
      >({
        query: (queryArg) => ({ url: `/profile/${queryArg}/admin` }),
        providesTags: ['profile'],
      }),
      profileControllerAddXp: build.mutation<
        ProfileControllerAddXpApiResponse,
        ProfileControllerAddXpApiArg
      >({
        query: (queryArg) => ({ url: '/profile/xp', method: 'POST', body: queryArg }),
        invalidatesTags: ['profile', 'users'],
      }),
      profileControllerAddTicket: build.mutation<
        ProfileControllerAddTicketApiResponse,
        ProfileControllerAddTicketApiArg
      >({
        query: (queryArg) => ({ url: '/profile/ticket', method: 'POST', body: queryArg }),
        invalidatesTags: ['profile', 'users'],
      }),
      profileControllerSearch: build.query<
        ProfileControllerSearchApiResponse,
        ProfileControllerSearchApiArg
      >({
        query: (queryArg) => ({
          url: '/profile/search',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['profile'],
      }),
      profileControllerFindAll: build.query<
        ProfileControllerFindAllApiResponse,
        ProfileControllerFindAllApiArg
      >({
        query: (queryArg) => ({
          url: '/profile',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['profile'],
      }),
      profileControllerFindOne: build.query<
        ProfileControllerFindOneApiResponse,
        ProfileControllerFindOneApiArg
      >({
        query: (queryArg) => ({ url: `/profile/${queryArg}` }),
        providesTags: ['profile'],
      }),
      fileControllerUploadUserAvatar: build.mutation<
        FileControllerUploadUserAvatarApiResponse,
        FileControllerUploadUserAvatarApiArg
      >({
        query: (queryArg) => ({ url: '/file/upload', method: 'POST', body: queryArg }),
        invalidatesTags: ['file'],
      }),
      notificationControllerCheck: build.query<
        NotificationControllerCheckApiResponse,
        NotificationControllerCheckApiArg
      >({
        query: (queryArg) => ({
          url: '/notifications/check',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['notification'],
      }),
      notificationControllerClearNotifications: build.mutation<
        NotificationControllerClearNotificationsApiResponse,
        NotificationControllerClearNotificationsApiArg
      >({
        query: (queryArg) => ({ url: '/notifications', method: 'DELETE', body: queryArg }),
        invalidatesTags: ['notification'],
      }),
      leaderboardControllerInsertToLeaderboard: build.mutation<
        LeaderboardControllerInsertToLeaderboardApiResponse,
        LeaderboardControllerInsertToLeaderboardApiArg
      >({
        query: () => ({ url: '/leaderboard/test', method: 'POST' }),
        invalidatesTags: ['leaderboard'],
      }),
      leaderboardControllerGetLeaderBoard: build.query<
        LeaderboardControllerGetLeaderBoardApiResponse,
        LeaderboardControllerGetLeaderBoardApiArg
      >({
        query: (queryArg) => ({
          url: `/leaderboard/${queryArg.tag}/${queryArg.entity}/${queryArg.date}`,
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['leaderboard'],
      }),
      clanControllerGetJoinRequests: build.query<
        ClanControllerGetJoinRequestsApiResponse,
        ClanControllerGetJoinRequestsApiArg
      >({
        query: (queryArg) => ({
          url: '/clan/join-requests',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['clan'],
      }),
      clanControllerCreateJoinRequest: build.mutation<
        ClanControllerCreateJoinRequestApiResponse,
        ClanControllerCreateJoinRequestApiArg
      >({
        query: (queryArg) => ({ url: '/clan/join-requests', method: 'POST', body: queryArg }),
        invalidatesTags: ['clan'],
      }),
      clanControllerApproveJoinRequest: build.mutation<
        ClanControllerApproveJoinRequestApiResponse,
        ClanControllerApproveJoinRequestApiArg
      >({
        query: (queryArg) => ({ url: `/clan/join-requests/${queryArg}/approve`, method: 'POST' }),
        invalidatesTags: ['clan'],
      }),
      clanControllerRemoveJoinRequest: build.mutation<
        ClanControllerRemoveJoinRequestApiResponse,
        ClanControllerRemoveJoinRequestApiArg
      >({
        query: (queryArg) => ({ url: `/clan/join-requests/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['clan'],
      }),
      clanControllerChangeRole: build.mutation<
        ClanControllerChangeRoleApiResponse,
        ClanControllerChangeRoleApiArg
      >({
        query: (queryArg) => ({
          url: `/clan/my-clan/${queryArg.userId}/change-role/${queryArg.role}`,
          method: 'PATCH',
        }),
        invalidatesTags: ['clan'],
      }),
      clanControllerRemoveMember: build.mutation<
        ClanControllerRemoveMemberApiResponse,
        ClanControllerRemoveMemberApiArg
      >({
        query: (queryArg) => ({ url: `/clan/my-clan/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['clan'],
      }),
      clanControllerFindMembers: build.query<
        ClanControllerFindMembersApiResponse,
        ClanControllerFindMembersApiArg
      >({
        query: (queryArg) => ({
          url: `/clan/${queryArg.id}/members`,
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['clan'],
      }),
      clanControllerUploadAvatar: build.mutation<
        ClanControllerUploadAvatarApiResponse,
        ClanControllerUploadAvatarApiArg
      >({
        query: (queryArg) => ({ url: '/clan/upload/avatar', method: 'POST', body: queryArg }),
        invalidatesTags: ['clan'],
      }),
      clanControllerIsNameAvailable: build.mutation<
        ClanControllerIsNameAvailableApiResponse,
        ClanControllerIsNameAvailableApiArg
      >({
        query: (queryArg) => ({ url: '/clan/is-name-available', method: 'POST', body: queryArg }),
        invalidatesTags: ['clan'],
      }),
      clanControllerCreate: build.mutation<
        ClanControllerCreateApiResponse,
        ClanControllerCreateApiArg
      >({
        query: (queryArg) => ({ url: '/clan', method: 'POST', body: queryArg }),
        invalidatesTags: ['clan'],
      }),
      clanControllerFindAll: build.query<
        ClanControllerFindAllApiResponse,
        ClanControllerFindAllApiArg
      >({
        query: (queryArg) => ({
          url: '/clan',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['clan'],
      }),
      clanControllerFindOne: build.query<
        ClanControllerFindOneApiResponse,
        ClanControllerFindOneApiArg
      >({
        query: (queryArg) => ({ url: `/clan/${queryArg}` }),
        providesTags: ['clan'],
      }),
      clanControllerUpdate: build.mutation<
        ClanControllerUpdateApiResponse,
        ClanControllerUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/clan/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.updateClanDto,
        }),
        invalidatesTags: ['clan'],
      }),
      customerControllerFindAllWithStats: build.query<
        CustomerControllerFindAllWithStatsApiResponse,
        CustomerControllerFindAllWithStatsApiArg
      >({
        query: (queryArg) => ({
          url: '/customers/with-stats',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['customer'],
      }),
      customerControllerFindOneWithStats: build.query<
        CustomerControllerFindOneWithStatsApiResponse,
        CustomerControllerFindOneWithStatsApiArg
      >({
        query: (queryArg) => ({ url: `/customers/${queryArg}/with-stats` }),
        providesTags: ['customer'],
      }),
      customerControllerAddBalance: build.mutation<
        CustomerControllerAddBalanceApiResponse,
        CustomerControllerAddBalanceApiArg
      >({
        query: (queryArg) => ({
          url: `/customers/${queryArg.id}/balance`,
          method: 'PUT',
          body: queryArg.customerAddBalanceDto,
        }),
        invalidatesTags: ['customer'],
      }),
      customerControllerUpdateAvatar: build.mutation<
        CustomerControllerUpdateAvatarApiResponse,
        CustomerControllerUpdateAvatarApiArg
      >({
        query: (queryArg) => ({
          url: `/customers/${queryArg.id}/avatar`,
          method: 'PUT',
          body: queryArg.body,
        }),
        invalidatesTags: ['customer'],
      }),
      customerControllerGetAvatar: build.query<
        CustomerControllerGetAvatarApiResponse,
        CustomerControllerGetAvatarApiArg
      >({
        query: (queryArg) => ({ url: `/customers/${queryArg}/avatar` }),
        providesTags: ['customer'],
      }),
      customerControllerCreate: build.mutation<
        CustomerControllerCreateApiResponse,
        CustomerControllerCreateApiArg
      >({
        query: (queryArg) => ({ url: '/customers', method: 'POST', body: queryArg }),
        invalidatesTags: ['customer'],
      }),
      customerControllerFindAll: build.query<
        CustomerControllerFindAllApiResponse,
        CustomerControllerFindAllApiArg
      >({
        query: (queryArg) => ({
          url: '/customers',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['customer', 'users'],
      }),
      customerControllerFindOne: build.query<
        CustomerControllerFindOneApiResponse,
        CustomerControllerFindOneApiArg
      >({
        query: (queryArg) => ({ url: `/customers/${queryArg}` }),
        providesTags: ['customer'],
      }),
      customerControllerUpdate: build.mutation<
        CustomerControllerUpdateApiResponse,
        CustomerControllerUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/customers/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.customerUpdateDto,
        }),
        invalidatesTags: ['customer'],
      }),
      customerControllerDelete: build.mutation<
        CustomerControllerDeleteApiResponse,
        CustomerControllerDeleteApiArg
      >({
        query: (queryArg) => ({ url: `/customers/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['customer'],
      }),
      customerControllerSelfUpdate: build.mutation<
        CustomerControllerSelfUpdateApiResponse,
        CustomerControllerSelfUpdateApiArg
      >({
        query: (queryArg) => ({ url: '/customers/self', method: 'POST', body: queryArg }),
        invalidatesTags: ['customer'],
      }),
      homeControllerGetInit: build.query<
        HomeControllerGetInitApiResponse,
        HomeControllerGetInitApiArg
      >({
        query: () => ({ url: '/home/init' }),
        providesTags: ['home', 'taskSettings'],
      }),
      homeControllerGetInitGuest: build.query<
        HomeControllerGetInitGuestApiResponse,
        HomeControllerGetInitGuestApiArg
      >({
        query: () => ({ url: '/home/init/guest' }),
        providesTags: ['home', 'taskSettings'],
      }),
      homeControllerGetSelf: build.query<
        HomeControllerGetSelfApiResponse,
        HomeControllerGetSelfApiArg
      >({
        query: () => ({ url: '/home/self' }),
        providesTags: ['home'],
      }),
      homeControllerGetGuestHomeData: build.query<
        HomeControllerGetGuestHomeDataApiResponse,
        HomeControllerGetGuestHomeDataApiArg
      >({
        query: () => ({ url: '/home/guest' }),
        providesTags: ['home'],
      }),
      homeControllerGetUserHomeData: build.query<
        HomeControllerGetUserHomeDataApiResponse,
        HomeControllerGetUserHomeDataApiArg
      >({
        query: () => ({ url: '/home/user' }),
        providesTags: ['home', 'invalidate-task', 'invalidate-giveaway'],
      }),
      homeControllerGetCompleteRates: build.query<
        HomeControllerGetCompleteRatesApiResponse,
        HomeControllerGetCompleteRatesApiArg
      >({
        query: () => ({ url: '/home/complete-rates' }),
        providesTags: ['home'],
      }),
      taskControllerFindTasksByFilters: build.query<
        TaskControllerFindTasksByFiltersApiResponse,
        TaskControllerFindTasksByFiltersApiArg
      >({
        query: (queryArg) => ({
          url: '/task/filter',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            customer: queryArg.customer,
            hideCustomer: queryArg.hideCustomer,
            date: queryArg.date,
            platform: queryArg.platform,
            action: queryArg.action,
            containsCompletedTasks: queryArg.containsCompletedTasks,
          },
        }),
        providesTags: ['task'],
      }),
      taskControllerFindAmpTasksByFilters: build.query<
        TaskControllerFindAmpTasksByFiltersApiResponse,
        TaskControllerFindAmpTasksByFiltersApiArg
      >({
        query: (queryArg) => ({
          url: '/task/amp-filter',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            customer: queryArg.customer,
            hideCustomer: queryArg.hideCustomer,
            date: queryArg.date,
            platform: queryArg.platform,
            action: queryArg.action,
            containsCompletedTasks: queryArg.containsCompletedTasks,
          },
        }),
        providesTags: ['task'],
      }),
      taskControllerFindCompletedAmpTasksByFilters: build.query<
        TaskControllerFindCompletedAmpTasksByFiltersApiResponse,
        TaskControllerFindCompletedAmpTasksByFiltersApiArg
      >({
        query: (queryArg) => ({
          url: '/task/amp-filter-completed',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            customer: queryArg.customer,
            hideCustomer: queryArg.hideCustomer,
            date: queryArg.date,
            platform: queryArg.platform,
            action: queryArg.action,
            containsCompletedTasks: queryArg.containsCompletedTasks,
          },
        }),
        providesTags: ['task'],
      }),
      taskControllerUpdateTaskSettings: build.mutation<
        TaskControllerUpdateTaskSettingsApiResponse,
        TaskControllerUpdateTaskSettingsApiArg
      >({
        query: (queryArg) => ({
          url: `/task/settings/${queryArg['type']}`,
          method: 'PATCH',
          body: queryArg.updateTaskSettingsDto,
        }),
        invalidatesTags: ['task', 'taskSettings'],
      }),
      taskControllerCreate: build.mutation<
        TaskControllerCreateApiResponse,
        TaskControllerCreateApiArg
      >({
        query: (queryArg) => ({ url: '/task', method: 'POST', body: queryArg }),
        invalidatesTags: ['task'],
      }),
      taskControllerFindAll: build.query<
        TaskControllerFindAllApiResponse,
        TaskControllerFindAllApiArg
      >({
        query: (queryArg) => ({
          url: '/task',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['task'],
      }),
      taskControllerFindPendingTask: build.query<
        TaskControllerFindPendingTaskApiResponse,
        TaskControllerFindPendingTaskApiArg
      >({
        query: (queryArg) => ({
          url: '/task/pending',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['task'],
      }),
      taskControllerFindOne: build.query<
        TaskControllerFindOneApiResponse,
        TaskControllerFindOneApiArg
      >({
        query: (queryArg) => ({ url: `/task/${queryArg}` }),
        providesTags: ['task'],
      }),
      taskControllerUpdate: build.mutation<
        TaskControllerUpdateApiResponse,
        TaskControllerUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/task/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.taskUpdateDto,
        }),
        invalidatesTags: ['task'],
      }),
      taskControllerRemove: build.mutation<
        TaskControllerRemoveApiResponse,
        TaskControllerRemoveApiArg
      >({
        query: (queryArg) => ({ url: `/task/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['task'],
      }),
      taskControllerVerifyTask: build.mutation<
        TaskControllerVerifyTaskApiResponse,
        TaskControllerVerifyTaskApiArg
      >({
        query: (queryArg) => ({ url: `/task/verify/${queryArg}`, method: 'POST' }),
        invalidatesTags: ['task', 'profile', 'home'],
      }),
      taskControllerApproveTask: build.mutation<
        TaskControllerApproveTaskApiResponse,
        TaskControllerApproveTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/task/${queryArg.id}/approve`,
          method: 'POST',
          body: queryArg.mongoDbIdDto,
        }),
        invalidatesTags: ['task'],
      }),
      taskControllerUnApproveTask: build.mutation<
        TaskControllerUnApproveTaskApiResponse,
        TaskControllerUnApproveTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/task/${queryArg.id}/un-approve`,
          method: 'POST',
          body: queryArg.mongoDbIdDto,
        }),
        invalidatesTags: ['task'],
      }),
      taskControllerJoinTask: build.mutation<
        TaskControllerJoinTaskApiResponse,
        TaskControllerJoinTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/task/join/${queryArg.id}`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['task'],
      }),
      taskControllerGetTaskParticipantData: build.query<
        TaskControllerGetTaskParticipantDataApiResponse,
        TaskControllerGetTaskParticipantDataApiArg
      >({
        query: (queryArg) => ({ url: `/task/${queryArg}/participant-data` }),
        providesTags: ['task'],
      }),
      taskControllerPause: build.mutation<
        TaskControllerPauseApiResponse,
        TaskControllerPauseApiArg
      >({
        query: (queryArg) => ({ url: `/task/pause/${queryArg}`, method: 'PUT' }),
        invalidatesTags: ['task'],
      }),
      taskControllerActivate: build.mutation<
        TaskControllerActivateApiResponse,
        TaskControllerActivateApiArg
      >({
        query: (queryArg) => ({ url: `/task/activate/${queryArg}`, method: 'PUT' }),
        invalidatesTags: ['task'],
      }),
      taskControllerFindParticipants: build.query<
        TaskControllerFindParticipantsApiResponse,
        TaskControllerFindParticipantsApiArg
      >({
        query: (queryArg) => ({
          url: `/task/${queryArg.id}/participants`,
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['task'],
      }),
      campaignControllerUpdateRewards: build.mutation<
        CampaignControllerUpdateRewardsApiResponse,
        CampaignControllerUpdateRewardsApiArg
      >({
        query: (queryArg) => ({
          url: `/campaigns/${queryArg.id}/rewards`,
          method: 'PATCH',
          body: queryArg.campaignUpdateRewardsDto,
        }),
        invalidatesTags: ['task'],
      }),
      campaignControllerFindAllParticipantsById: build.query<
        CampaignControllerFindAllParticipantsByIdApiResponse,
        CampaignControllerFindAllParticipantsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/campaigns/${queryArg.id}/participants`,
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['task', 'users'],
      }),
      campaignControllerFindAllPublicParticipantsById: build.query<
        CampaignControllerFindAllPublicParticipantsByIdApiResponse,
        CampaignControllerFindAllPublicParticipantsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/campaigns/${queryArg.id}/publicParticipants`,
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['task', 'users'],
      }),
      campaignControllerFindAllWinnersById: build.query<
        CampaignControllerFindAllWinnersByIdApiResponse,
        CampaignControllerFindAllWinnersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/campaigns/${queryArg.id}/winners`,
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['task', 'users'],
      }),
      campaignControllerGetImage: build.query<
        CampaignControllerGetImageApiResponse,
        CampaignControllerGetImageApiArg
      >({
        query: (queryArg) => ({ url: `/campaigns/${queryArg}/image` }),
        providesTags: ['task'],
      }),
      campaignControllerUploadImage: build.mutation<
        CampaignControllerUploadImageApiResponse,
        CampaignControllerUploadImageApiArg
      >({
        query: (queryArg) => ({
          url: `/campaigns/${queryArg.id}/image`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['task'],
      }),
      campaignControllerFindAllTasks: build.query<
        CampaignControllerFindAllTasksApiResponse,
        CampaignControllerFindAllTasksApiArg
      >({
        query: (queryArg) => ({ url: `/campaigns/${queryArg}/tasks` }),
        providesTags: ['task'],
      }),
      campaignControllerUpsertTask: build.mutation<
        CampaignControllerUpsertTaskApiResponse,
        CampaignControllerUpsertTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/campaigns/${queryArg.id}/tasks`,
          method: 'POST',
          body: queryArg.campaignTaskUpsertDto,
        }),
        invalidatesTags: ['task'],
      }),
      campaignControllerRemoveTask: build.mutation<
        CampaignControllerRemoveTaskApiResponse,
        CampaignControllerRemoveTaskApiArg
      >({
        query: (queryArg) => ({
          url: `/campaigns/${queryArg.id}/tasks`,
          method: 'DELETE',
          body: queryArg.mongoDbIdDto,
        }),
        invalidatesTags: ['task'],
      }),
      campaignControllerVerifyCampaign: build.mutation<
        CampaignControllerVerifyCampaignApiResponse,
        CampaignControllerVerifyCampaignApiArg
      >({
        query: (queryArg) => ({ url: `/campaigns/${queryArg}/verify`, method: 'POST' }),
        invalidatesTags: ['task'],
      }),
      campaignControllerPause: build.mutation<
        CampaignControllerPauseApiResponse,
        CampaignControllerPauseApiArg
      >({
        query: (queryArg) => ({ url: `/campaigns/${queryArg}/pause`, method: 'PUT' }),
        invalidatesTags: ['task'],
      }),
      campaignControllerActivate: build.mutation<
        CampaignControllerActivateApiResponse,
        CampaignControllerActivateApiArg
      >({
        query: (queryArg) => ({ url: `/campaigns/${queryArg}/activate`, method: 'PUT' }),
        invalidatesTags: ['task'],
      }),
      campaignControllerWinner: build.mutation<
        CampaignControllerWinnerApiResponse,
        CampaignControllerWinnerApiArg
      >({
        query: (queryArg) => ({
          url: `/campaigns/${queryArg.id}/winner`,
          method: 'PUT',
          body: queryArg.mongoDbIdDto,
        }),
        invalidatesTags: ['task'],
      }),
      campaignControllerFindAllPublic: build.query<
        CampaignControllerFindAllPublicApiResponse,
        CampaignControllerFindAllPublicApiArg
      >({
        query: (queryArg) => ({
          url: '/campaigns/public',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['task'],
      }),
      campaignControllerFindAllPublicWithAuth: build.query<
        CampaignControllerFindAllPublicWithAuthApiResponse,
        CampaignControllerFindAllPublicWithAuthApiArg
      >({
        query: (queryArg) => ({
          url: '/campaigns/public/auth',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['task'],
      }),
      campaignControllerFindAllGuestWithAuth: build.query<
        CampaignControllerFindAllGuestWithAuthApiResponse,
        CampaignControllerFindAllGuestWithAuthApiArg
      >({
        query: (queryArg) => ({
          url: '/campaigns/guest/auth',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['task'],
      }),
      campaignControllerFindOnePublic: build.query<
        CampaignControllerFindOnePublicApiResponse,
        CampaignControllerFindOnePublicApiArg
      >({
        query: (queryArg) => ({ url: `/campaigns/${queryArg}/public` }),
        providesTags: ['task'],
      }),
      campaignControllerFindOneGuest: build.query<
        CampaignControllerFindOneGuestApiResponse,
        CampaignControllerFindOneGuestApiArg
      >({
        query: (queryArg) => ({ url: `/campaigns/${queryArg}/guest` }),
        providesTags: ['task'],
      }),
      campaignControllerCreate: build.mutation<
        CampaignControllerCreateApiResponse,
        CampaignControllerCreateApiArg
      >({
        query: (queryArg) => ({ url: '/campaigns', method: 'POST', body: queryArg }),
        invalidatesTags: ['task'],
      }),
      campaignControllerFindAll: build.query<
        CampaignControllerFindAllApiResponse,
        CampaignControllerFindAllApiArg
      >({
        query: (queryArg) => ({
          url: '/campaigns',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['task'],
      }),
      campaignControllerFindOne: build.query<
        CampaignControllerFindOneApiResponse,
        CampaignControllerFindOneApiArg
      >({
        query: (queryArg) => ({ url: `/campaigns/${queryArg}` }),
        providesTags: ['task'],
      }),
      campaignControllerUpdate: build.mutation<
        CampaignControllerUpdateApiResponse,
        CampaignControllerUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/campaigns/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.campaignUpdateDto,
        }),
        invalidatesTags: ['task'],
      }),
      campaignControllerRemove: build.mutation<
        CampaignControllerRemoveApiResponse,
        CampaignControllerRemoveApiArg
      >({
        query: (queryArg) => ({ url: `/campaigns/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['task'],
      }),
      giveawayControllerJoin: build.mutation<
        GiveawayControllerJoinApiResponse,
        GiveawayControllerJoinApiArg
      >({
        query: (queryArg) => ({
          url: `/giveaway/${queryArg.id}/join`,
          method: 'POST',
          body: queryArg.giveawayJoinDto,
        }),
        invalidatesTags: ['giveaway', 'invalidate-giveaway'],
      }),
      giveawayControllerFindAllParticipantsById: build.query<
        GiveawayControllerFindAllParticipantsByIdApiResponse,
        GiveawayControllerFindAllParticipantsByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/giveaway/${queryArg.id}/participants`,
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['giveaway', 'users'],
      }),
      giveawayControllerFindAllWinnersById: build.query<
        GiveawayControllerFindAllWinnersByIdApiResponse,
        GiveawayControllerFindAllWinnersByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/giveaway/${queryArg.id}/winners`,
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['giveaway', 'users'],
      }),
      giveawayControllerGetRewards: build.query<
        GiveawayControllerGetRewardsApiResponse,
        GiveawayControllerGetRewardsApiArg
      >({
        query: () => ({ url: '/giveaway/user/rewards' }),
        providesTags: ['giveaway'],
      }),
      giveawayControllerSetWalletForReward: build.mutation<
        GiveawayControllerSetWalletForRewardApiResponse,
        GiveawayControllerSetWalletForRewardApiArg
      >({
        query: (queryArg) => ({ url: '/giveaway/wallet/set', method: 'PATCH', body: queryArg }),
        invalidatesTags: ['giveaway'],
      }),
      giveawayControllerCronJobs: build.query<
        GiveawayControllerCronJobsApiResponse,
        GiveawayControllerCronJobsApiArg
      >({
        query: () => ({ url: '/giveaway/trigger/cron' }),
        providesTags: ['giveaway'],
      }),
      giveawayControllerPause: build.mutation<
        GiveawayControllerPauseApiResponse,
        GiveawayControllerPauseApiArg
      >({
        query: (queryArg) => ({ url: `/giveaway/pause/${queryArg}`, method: 'PUT' }),
        invalidatesTags: ['giveaway'],
      }),
      giveawayControllerActivate: build.mutation<
        GiveawayControllerActivateApiResponse,
        GiveawayControllerActivateApiArg
      >({
        query: (queryArg) => ({ url: `/giveaway/activate/${queryArg}`, method: 'PUT' }),
        invalidatesTags: ['giveaway'],
      }),
      giveawayControllerFindAllPublic: build.query<
        GiveawayControllerFindAllPublicApiResponse,
        GiveawayControllerFindAllPublicApiArg
      >({
        query: () => ({ url: '/giveaway/public' }),
        providesTags: ['giveaway'],
      }),
      giveawayControllerCreate: build.mutation<
        GiveawayControllerCreateApiResponse,
        GiveawayControllerCreateApiArg
      >({
        query: (queryArg) => ({ url: '/giveaway', method: 'POST', body: queryArg }),
        invalidatesTags: ['giveaway'],
      }),
      giveawayControllerFindAll: build.query<
        GiveawayControllerFindAllApiResponse,
        GiveawayControllerFindAllApiArg
      >({
        query: (queryArg) => ({
          url: '/giveaway',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['giveaway'],
      }),
      giveawayControllerFindOne: build.query<
        GiveawayControllerFindOneApiResponse,
        GiveawayControllerFindOneApiArg
      >({
        query: (queryArg) => ({ url: `/giveaway/${queryArg}` }),
        providesTags: ['giveaway'],
      }),
      giveawayControllerUpdate: build.mutation<
        GiveawayControllerUpdateApiResponse,
        GiveawayControllerUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/giveaway/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.giveawayUpdateDto,
        }),
        invalidatesTags: ['giveaway'],
      }),
      giveawayControllerDelete: build.mutation<
        GiveawayControllerDeleteApiResponse,
        GiveawayControllerDeleteApiArg
      >({
        query: (queryArg) => ({ url: `/giveaway/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['giveaway'],
      }),
      dailyRewardControllerGetActiveCampaignStatus: build.query<
        DailyRewardControllerGetActiveCampaignStatusApiResponse,
        DailyRewardControllerGetActiveCampaignStatusApiArg
      >({
        query: () => ({ url: '/rewards/active' }),
        providesTags: ['Rewards'],
      }),
      dailyRewardControllerClaim: build.mutation<
        DailyRewardControllerClaimApiResponse,
        DailyRewardControllerClaimApiArg
      >({
        query: () => ({ url: '/rewards/claim', method: 'POST' }),
        invalidatesTags: ['Rewards'],
      }),
      dailyRewardControllerPause: build.mutation<
        DailyRewardControllerPauseApiResponse,
        DailyRewardControllerPauseApiArg
      >({
        query: (queryArg) => ({ url: `/rewards/pause/${queryArg}`, method: 'PUT' }),
        invalidatesTags: ['Rewards'],
      }),
      dailyRewardControllerActivate: build.mutation<
        DailyRewardControllerActivateApiResponse,
        DailyRewardControllerActivateApiArg
      >({
        query: (queryArg) => ({ url: `/rewards/activate/${queryArg}`, method: 'PUT' }),
        invalidatesTags: ['Rewards'],
      }),
      dailyRewardControllerCreate: build.mutation<
        DailyRewardControllerCreateApiResponse,
        DailyRewardControllerCreateApiArg
      >({
        query: (queryArg) => ({ url: '/rewards', method: 'POST', body: queryArg }),
        invalidatesTags: ['Rewards'],
      }),
      dailyRewardControllerFindAll: build.query<
        DailyRewardControllerFindAllApiResponse,
        DailyRewardControllerFindAllApiArg
      >({
        query: (queryArg) => ({
          url: '/rewards',
          params: {
            page: queryArg.page,
            limit: queryArg.limit,
            search: queryArg.search,
            status: queryArg.status,
            role: queryArg.role,
          },
        }),
        providesTags: ['Rewards'],
      }),
      dailyRewardControllerFindOne: build.query<
        DailyRewardControllerFindOneApiResponse,
        DailyRewardControllerFindOneApiArg
      >({
        query: (queryArg) => ({ url: `/rewards/${queryArg}` }),
        providesTags: ['Rewards'],
      }),
      dailyRewardControllerUpdate: build.mutation<
        DailyRewardControllerUpdateApiResponse,
        DailyRewardControllerUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/rewards/${queryArg.id}`,
          method: 'PATCH',
          body: queryArg.dailyCampaignUpdateDto,
        }),
        invalidatesTags: ['Rewards'],
      }),
      dailyRewardControllerDelete: build.mutation<
        DailyRewardControllerDeleteApiResponse,
        DailyRewardControllerDeleteApiArg
      >({
        query: (queryArg) => ({ url: `/rewards/${queryArg}`, method: 'DELETE' }),
        invalidatesTags: ['Rewards'],
      }),
      statisticsControllerSummary: build.query<
        StatisticsControllerSummaryApiResponse,
        StatisticsControllerSummaryApiArg
      >({
        query: () => ({ url: '/statistics/summary' }),
        providesTags: ['statistics'],
      }),
      statisticsControllerSummaryPublic: build.query<
        StatisticsControllerSummaryPublicApiResponse,
        StatisticsControllerSummaryPublicApiArg
      >({
        query: () => ({ url: '/statistics/summaryPublic' }),
        providesTags: ['statistics'],
      }),
      statisticsControllerUserAcquisition: build.query<
        StatisticsControllerUserAcquisitionApiResponse,
        StatisticsControllerUserAcquisitionApiArg
      >({
        query: () => ({ url: '/statistics/userAcquisition' }),
        providesTags: ['statistics'],
      }),
      statisticsControllerTaskInteractionData: build.query<
        StatisticsControllerTaskInteractionDataApiResponse,
        StatisticsControllerTaskInteractionDataApiArg
      >({
        query: () => ({ url: '/statistics/taskInteraction' }),
        providesTags: ['statistics'],
      }),
      statisticsControllerPointDistribution: build.query<
        StatisticsControllerPointDistributionApiResponse,
        StatisticsControllerPointDistributionApiArg
      >({
        query: () => ({ url: '/statistics/pointDistribution' }),
        providesTags: ['statistics'],
      }),
      statisticsControllerUsersByLocation: build.query<
        StatisticsControllerUsersByLocationApiResponse,
        StatisticsControllerUsersByLocationApiArg
      >({
        query: () => ({ url: '/statistics/usersByLocation' }),
        providesTags: ['statistics'],
      }),
      statisticsControllerGetCustomerInfo: build.query<
        StatisticsControllerGetCustomerInfoApiResponse,
        StatisticsControllerGetCustomerInfoApiArg
      >({
        query: () => ({ url: '/statistics/customer/info' }),
        providesTags: ['statistics'],
      }),
      statisticsControllerGetStatsGoogle: build.query<
        StatisticsControllerGetStatsGoogleApiResponse,
        StatisticsControllerGetStatsGoogleApiArg
      >({
        query: () => ({ url: '/statistics/get-stats-from-google' }),
        providesTags: ['statistics'],
      }),
      midleTasksControllerIsAccountConnected: build.query<
        MidleTasksControllerIsAccountConnectedApiResponse,
        MidleTasksControllerIsAccountConnectedApiArg
      >({
        query: (queryArg) => ({
          url: `/midle-tasks/connect/${queryArg.provider}`,
          params: { userId: queryArg.userId },
        }),
        providesTags: ['MidleTasks'],
      }),
      midleTasksControllerCheckRefCode: build.mutation<
        MidleTasksControllerCheckRefCodeApiResponse,
        MidleTasksControllerCheckRefCodeApiArg
      >({
        query: (queryArg) => ({
          url: '/midle-tasks/ref',
          method: 'POST',
          body: queryArg.taskCustomCheckDto,
          params: { userId: queryArg.userId },
        }),
        invalidatesTags: ['MidleTasks'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as midleNestApi };
export type AppControllerGetTestApiResponse = unknown;
export type AppControllerGetTestApiArg = void;
export type AppControllerGetTime2ApiResponse = unknown;
export type AppControllerGetTime2ApiArg = void;
export type AppControllerGetTime1ApiResponse = unknown;
export type AppControllerGetTime1ApiArg = void;
export type AppControllerGetTime3ApiResponse = unknown;
export type AppControllerGetTime3ApiArg = void;
export type AppControllerGetVersionApiResponse = unknown;
export type AppControllerGetVersionApiArg = void;
export type AuthControllerRemoveApiResponse = /** status 200  */ ResponseMessageDto;
export type AuthControllerRemoveApiArg = void;
export type AuthControllerRegisterApiResponse = /** status 201  User created!  */ AuthDto;
export type AuthControllerRegisterApiArg = RegisterDto;
export type AuthControllerLoginApiResponse = /** status 200  */ AuthDto;
export type AuthControllerLoginApiArg = LoginDto;
export type AuthControllerRefreshApiResponse = /** status 201  */ RefreshDto;
export type AuthControllerRefreshApiArg = void;
export type AuthControllerUnVerifiedAccountsApiResponse =
  /** status 200 Account list for verification. */ Account[];
export type AuthControllerUnVerifiedAccountsApiArg = void;
export type AuthControllerVerifyApiResponse = /** status 200   */ AuthDto;
export type AuthControllerVerifyApiArg = void;
export type AuthControllerRecoveryApiResponse = /** status 200   */ ResponseMessageDto;
export type AuthControllerRecoveryApiArg = RecoveryDto;
export type AuthControllerResetApiResponse = /** status 200  */ ResetResponseDto;
export type AuthControllerResetApiArg = ResetPasswordDto;
export type AuthControllerLogoutApiResponse = /** status 201  */ Logout;
export type AuthControllerLogoutApiArg = void;
export type AuthControllerChangePasswordApiResponse = /** status 200  */ ResponseMessageDto;
export type AuthControllerChangePasswordApiArg = UpdatePasswordDto;
export type AuthControllerSetUsernameApiResponse = /** status 200  */ ResponseMessageDto;
export type AuthControllerSetUsernameApiArg = UpdateUsernameDto;
export type AuthControllerClaimApiResponse = /** status 200  */ AuthDto;
export type AuthControllerClaimApiArg = ClaimDto;
export type WalletControllerAuthenticateApiResponse =
  /** status 201 It returns WalletResponseDto */ AuthDto;
export type WalletControllerAuthenticateApiArg = WalletLoginDto;
export type WalletControllerGetMetamaskLoginMessageApiResponse =
  /** status 200 It returns Metamask Login Message String */ WalletLoginMessageDto;
export type WalletControllerGetMetamaskLoginMessageApiArg = string;
export type WalletControllerDisconnectWalletApiResponse =
  /** status 200 It returns success message */ WalletLoginMessageDto;
export type WalletControllerDisconnectWalletApiArg = SocialDisconnectDto;
export type WalletControllerConnectWalletApiResponse =
  /** status 201 It returns WalletResponseDto */ WalletLoginMessageDto;
export type WalletControllerConnectWalletApiArg = WalletLoginDto;
export type TwitterControllerGetAuthorizeUrlApiResponse = /** status 200   */ AuthorizeUrlDto;
export type TwitterControllerGetAuthorizeUrlApiArg = void;
export type TwitterControllerAuthenticateApiResponse = /** status 201  */ AuthDto;
export type TwitterControllerAuthenticateApiArg = TwitterConnectDto;
export type TwitterControllerConnectApiResponse = /** status 201  */ ResponseMessageDto;
export type TwitterControllerConnectApiArg = TwitterConnectDto;
export type TwitterControllerDisconnectApiResponse = /** status 201  */ ResponseMessageDto;
export type TwitterControllerDisconnectApiArg = SocialDisconnectDto;
export type GoogleControllerAuthenticateApiResponse = /** status 201  */ AuthDto;
export type GoogleControllerAuthenticateApiArg = BaseConnectDto;
export type GoogleControllerGetAuthorizeUrlApiResponse = /** status 200   */ AuthorizeUrlDto;
export type GoogleControllerGetAuthorizeUrlApiArg = void;
export type GoogleControllerConnectApiResponse = /** status 201  */ ResponseMessageDto;
export type GoogleControllerConnectApiArg = BaseConnectDto;
export type GoogleControllerDisconnectApiResponse = /** status 201  */ ResponseMessageDto;
export type GoogleControllerDisconnectApiArg = SocialDisconnectDto;
export type GithubControllerAuthenticateApiResponse = /** status 201  */ AuthDto;
export type GithubControllerAuthenticateApiArg = BaseConnectDto;
export type GithubControllerGetAuthorizeUrlApiResponse = /** status 200   */ AuthorizeUrlDto;
export type GithubControllerGetAuthorizeUrlApiArg = void;
export type GithubControllerConnectApiResponse = /** status 201  */ ResponseMessageDto;
export type GithubControllerConnectApiArg = BaseConnectDto;
export type GithubControllerDisconnectApiResponse = /** status 201  */ ResponseMessageDto;
export type GithubControllerDisconnectApiArg = SocialDisconnectDto;
export type TelegramControllerAuthenticateApiResponse = /** status 201  */ AuthDto;
export type TelegramControllerAuthenticateApiArg = TelegramConnectDto;
export type TelegramControllerConnectApiResponse = /** status 201  */ ResponseMessageDto;
export type TelegramControllerConnectApiArg = TelegramConnectDto;
export type TelegramControllerDisconnectApiResponse = /** status 201  */ ResponseMessageDto;
export type TelegramControllerDisconnectApiArg = SocialDisconnectDto;
export type DiscordControllerAuthenticateApiResponse = /** status 201  */ AuthDto;
export type DiscordControllerAuthenticateApiArg = BaseConnectDto;
export type DiscordControllerGetAuthorizeUrlApiResponse = /** status 200   */ AuthorizeUrlDto;
export type DiscordControllerGetAuthorizeUrlApiArg = void;
export type DiscordControllerConnectApiResponse = /** status 201  */ ResponseMessageDto;
export type DiscordControllerConnectApiArg = BaseConnectDto;
export type DiscordControllerDisconnectApiResponse = /** status 201  */ ResponseMessageDto;
export type DiscordControllerDisconnectApiArg = SocialDisconnectDto;
export type SteamControllerAuthenticateApiResponse = /** status 201  */ AuthDto;
export type SteamControllerAuthenticateApiArg = SteamConnectDto;
export type SteamControllerGetAuthorizeUrlApiResponse = /** status 200   */ AuthorizeUrlDto;
export type SteamControllerGetAuthorizeUrlApiArg = void;
export type SteamControllerConnectApiResponse = /** status 201  */ ResponseMessageDto;
export type SteamControllerConnectApiArg = SteamConnectDto;
export type SteamControllerDisconnectApiResponse = /** status 201  */ ResponseMessageDto;
export type SteamControllerDisconnectApiArg = SocialDisconnectDto;
export type RedditControllerAuthenticateApiResponse = /** status 201  */ AuthDto;
export type RedditControllerAuthenticateApiArg = RedditConnectDto;
export type RedditControllerGetAuthorizeUrlApiResponse = /** status 200   */ AuthorizeUrlDto;
export type RedditControllerGetAuthorizeUrlApiArg = void;
export type RedditControllerConnectApiResponse = /** status 201  */ ResponseMessageDto;
export type RedditControllerConnectApiArg = RedditConnectDto;
export type RedditControllerDisconnectApiResponse = /** status 201  */ ResponseMessageDto;
export type RedditControllerDisconnectApiArg = SocialDisconnectDto;
export type SpotifyControllerAuthenticateApiResponse = /** status 201  */ AuthDto;
export type SpotifyControllerAuthenticateApiArg = SpotifyConnectDto;
export type SpotifyControllerGetAuthorizeUrlApiResponse = /** status 200   */ AuthorizeUrlDto;
export type SpotifyControllerGetAuthorizeUrlApiArg = void;
export type SpotifyControllerConnectApiResponse = /** status 201  */ ResponseMessageDto;
export type SpotifyControllerConnectApiArg = SpotifyConnectDto;
export type SpotifyControllerDisconnectApiResponse = /** status 201  */ ResponseMessageDto;
export type SpotifyControllerDisconnectApiArg = SocialDisconnectDto;
export type AppleControllerAuthenticateApiResponse = /** status 201  */ AuthDto;
export type AppleControllerAuthenticateApiArg = AppleLoginDto;
export type AppleControllerConnectApiResponse = /** status 201  */ ResponseMessageDto;
export type AppleControllerConnectApiArg = AppleLoginDto;
export type AppleControllerDisconnectApiResponse = /** status 201  */ ResponseMessageDto;
export type AppleControllerDisconnectApiArg = SocialDisconnectDto;
export type CosmosControllerAuthenticateApiResponse =
  /** status 201 It returns WalletResponseDto */ AuthDto;
export type CosmosControllerAuthenticateApiArg = CosmosLoginDto;
export type CosmosControllerGetCosmosLoginMessageApiResponse =
  /** status 200 It returns cosmos Login Message String */ WalletLoginMessageDto;
export type CosmosControllerGetCosmosLoginMessageApiArg = string;
export type CosmosControllerDisconnectCosmosApiResponse =
  /** status 200 It returns success message */ WalletLoginMessageDto;
export type CosmosControllerDisconnectCosmosApiArg = SocialDisconnectDto;
export type CosmosControllerConnectWalletApiResponse =
  /** status 201 It returns WalletResponseDto */ WalletLoginMessageDto;
export type CosmosControllerConnectWalletApiArg = CosmosLoginDto;
export type VerificationControllerVerifyApiResponse = /** status 200  */ VerifyResponseDto;
export type VerificationControllerVerifyApiArg = VerifyDto;
export type VerificationControllerResendApiResponse = /** status 200  */ ResponseMessageDto;
export type VerificationControllerResendApiArg = ResendDto;
export type AccountsControllerAddApiResponse = /** status 201  */ AccountDto[];
export type AccountsControllerAddApiArg = AddAccountDto;
export type AccountsControllerFindApiResponse = /** status 200  */ AccountDto[];
export type AccountsControllerFindApiArg = {
  provider: string;
  identity: string;
  isVerified: boolean;
  username: string;
};
export type AccountsControllerUpdateApiResponse = /** status 200  */ ResponseMessageDto;
export type AccountsControllerUpdateApiArg = AccountDto;
export type AccountsControllerRemoveApiResponse = /** status 200  */ AccountDto[];
export type AccountsControllerRemoveApiArg = AccountDto;
export type AccountsControllerAddEmailApiResponse = /** status 201  */ AccountDto[];
export type AccountsControllerAddEmailApiArg = AddAccountDto;
export type AccountsControllerGetAccountsApiResponse = /** status 200  */ AccountDto[];
export type AccountsControllerGetAccountsApiArg = string;
export type AccountsControllerVerifyAccountApiResponse =
  /** status 200 Account list for verification. */ AccountDto[];
export type AccountsControllerVerifyAccountApiArg = VerifyAccountDto;
export type AccountsControllerSetPrimaryApiResponse = /** status 200  */ AccountDto[];
export type AccountsControllerSetPrimaryApiArg = AccountDto;
export type UsersControllerCreateApiResponse = /** status 201  */ UserDtoRead;
export type UsersControllerCreateApiArg = CreateUserDto;
export type UsersControllerUpdateApiResponse = /** status 200  */ ResponseMessageDto;
export type UsersControllerUpdateApiArg = {
  /** Mongo id */
  id: string;
  updateUserDto: UpdateUserDto;
};
export type UsersControllerRemoveApiResponse = /** status 200  */ ResponseMessageDto;
export type UsersControllerRemoveApiArg = /** Mongo id */ string;
export type UsersControllerRoleChangeApiResponse = /** status 200  */ ResponseMessageDto;
export type UsersControllerRoleChangeApiArg = {
  /** Mongo id */
  id: string;
  updateRolesDto: UpdateRolesDto;
};
export type UsersControllerChangePasswordApiResponse = /** status 200  */ ResponseMessageDto;
export type UsersControllerChangePasswordApiArg = {
  /** Mongo id */
  id: string;
  updatePasswordDto: UpdatePasswordDto;
};
export type ProfileControllerGetUserAvatarApiResponse = /** status 200  Avatar image  */ AvatarDto;
export type ProfileControllerGetUserAvatarApiArg = void;
export type ProfileControllerUploadUserAvatarApiResponse =
  /** status 201  Avatar uploaded!  */ ResponseStatusDto;
export type ProfileControllerUploadUserAvatarApiArg = {
  /** The file to upload */
  file?: Blob;
};
export type ProfileControllerGetUserDetailsWithCustomerApiResponse =
  /** status 200  object of user information.  */ ProfileSemiPrivateDtoRead;
export type ProfileControllerGetUserDetailsWithCustomerApiArg = /** Mongo id */ string;
export type ProfileControllerGetUserDetailsWithAdminApiResponse =
  /** status 200  object of user information.  */ ProfilePrivateDtoRead;
export type ProfileControllerGetUserDetailsWithAdminApiArg = /** Mongo id */ string;
export type ProfileControllerAddXpApiResponse = /** status 201 Add Xp for user  */ AddXpResponseDto;
export type ProfileControllerAddXpApiArg = AddXpDto;
export type ProfileControllerAddTicketApiResponse =
  /** status 201 Add Ticket for user  */ AddTicketResponseDto;
export type ProfileControllerAddTicketApiArg = AddTicketDto;
export type ProfileControllerSearchApiResponse = /** status 200  */ PaginatedDto & {
  list?: ProfileInfoDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type ProfileControllerSearchApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type ProfileControllerFindAllApiResponse = /** status 200  */ PaginatedDto & {
  list?: ProfilePrivateDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type ProfileControllerFindAllApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type ProfileControllerFindOneApiResponse = /** status 200  */ ProfilePrivateDtoRead;
export type ProfileControllerFindOneApiArg = /** Mongo id */ string;
export type FileControllerUploadUserAvatarApiResponse = /** status 201 File uploaded! */ FileDto;
export type FileControllerUploadUserAvatarApiArg = {
  /** The file to upload */
  file?: Blob;
};
export type NotificationControllerCheckApiResponse =
  /** status 200 Notifications */ NotificationResponseDtoRead;
export type NotificationControllerCheckApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type NotificationControllerClearNotificationsApiResponse =
  /** status 200 Notifications */ ResponseMessageDto;
export type NotificationControllerClearNotificationsApiArg = NotificationIdListDto;
export type LeaderboardControllerInsertToLeaderboardApiResponse = unknown;
export type LeaderboardControllerInsertToLeaderboardApiArg = void;
export type LeaderboardControllerGetLeaderBoardApiResponse =
  /** status 200 Leaderboard */ LeaderboardResponseDto;
export type LeaderboardControllerGetLeaderBoardApiArg = {
  tag: string;
  entity: string;
  date: string;
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type ClanControllerGetJoinRequestsApiResponse = /** status 200  */ PaginatedDto & {
  list?: ClanJoinRequestDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type ClanControllerGetJoinRequestsApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type ClanControllerCreateJoinRequestApiResponse = /** status 201  */ ResponseIdDto;
export type ClanControllerCreateJoinRequestApiArg = ClanJoinRequestCreateDto;
export type ClanControllerApproveJoinRequestApiResponse = /** status 201  */ ResponseIdDto;
export type ClanControllerApproveJoinRequestApiArg = /** Mongo id */ string;
export type ClanControllerRemoveJoinRequestApiResponse = /** status 200  */ ResponseIdDto;
export type ClanControllerRemoveJoinRequestApiArg = string;
export type ClanControllerChangeRoleApiResponse = /** status 200  */ ResponseIdDto;
export type ClanControllerChangeRoleApiArg = {
  userId: string;
  role: string;
};
export type ClanControllerRemoveMemberApiResponse = /** status 200  */ ResponseIdDto;
export type ClanControllerRemoveMemberApiArg = /** Mongo id */ string;
export type ClanControllerFindMembersApiResponse = /** status 200  */ PaginatedDto & {
  list?: ClanMemberWithStatsDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type ClanControllerFindMembersApiArg = {
  /** Mongo id */
  id: string;
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type ClanControllerUploadAvatarApiResponse =
  /** status 201  Avatar uploaded!  */ ResponseStatusDto;
export type ClanControllerUploadAvatarApiArg = {
  /** The file to upload */
  file?: Blob;
};
export type ClanControllerIsNameAvailableApiResponse = unknown;
export type ClanControllerIsNameAvailableApiArg = CreateClanDto;
export type ClanControllerCreateApiResponse = /** status 201  */ ResponseIdDto;
export type ClanControllerCreateApiArg = CreateClanDto;
export type ClanControllerFindAllApiResponse = /** status 200  */ PaginatedDto & {
  list?: ClanWithStatsDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type ClanControllerFindAllApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type ClanControllerFindOneApiResponse = /** status 200  */ ClanWithStatsDtoRead;
export type ClanControllerFindOneApiArg = string;
export type ClanControllerUpdateApiResponse = /** status 200  */ ResponseIdDto;
export type ClanControllerUpdateApiArg = {
  /** Mongo id */
  id: string;
  updateClanDto: UpdateClanDto;
};
export type CustomerControllerFindAllWithStatsApiResponse = /** status 200  */ PaginatedDto & {
  list?: CustomerWithStatsDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type CustomerControllerFindAllWithStatsApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type CustomerControllerFindOneWithStatsApiResponse =
  /** status 200  */ CustomerWithStatsDtoRead;
export type CustomerControllerFindOneWithStatsApiArg = string;
export type CustomerControllerAddBalanceApiResponse = /** status 200  */ ResponseIdDto;
export type CustomerControllerAddBalanceApiArg = {
  id: string;
  customerAddBalanceDto: CustomerAddBalanceDto;
};
export type CustomerControllerUpdateAvatarApiResponse = /** status 201  */ ResponseStatusDto;
export type CustomerControllerUpdateAvatarApiArg = {
  /** Mongo id */
  id: string;
  body: {
    /** The file to upload */
    file?: Blob;
  };
};
export type CustomerControllerGetAvatarApiResponse = /** status 201  */ AvatarDto;
export type CustomerControllerGetAvatarApiArg = /** customer ID */ string;
export type CustomerControllerCreateApiResponse =
  /** status 201  Customer created!  */ ResponseIdDto;
export type CustomerControllerCreateApiArg = CustomerCreateDto;
export type CustomerControllerFindAllApiResponse = /** status 200  */ PaginatedDto & {
  list?: ProfileCustomerDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type CustomerControllerFindAllApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type CustomerControllerFindOneApiResponse = /** status 200  */ CustomerPrivateDtoRead;
export type CustomerControllerFindOneApiArg = string;
export type CustomerControllerUpdateApiResponse = /** status 200  */ ResponseIdDto;
export type CustomerControllerUpdateApiArg = {
  id: string;
  customerUpdateDto: CustomerUpdateDto;
};
export type CustomerControllerDeleteApiResponse = /** status 200  */ ResponseIdDto;
export type CustomerControllerDeleteApiArg = string;
export type CustomerControllerSelfUpdateApiResponse = /** status 200  */ ResponseIdDto;
export type CustomerControllerSelfUpdateApiArg = CustomerUpdateDto;
export type HomeControllerGetInitApiResponse = /** status 200  Home init data */ InitData;
export type HomeControllerGetInitApiArg = void;
export type HomeControllerGetInitGuestApiResponse = /** status 200  Home init data */ InitData;
export type HomeControllerGetInitGuestApiArg = void;
export type HomeControllerGetSelfApiResponse = /** status 200  */ SelfDtoRead;
export type HomeControllerGetSelfApiArg = void;
export type HomeControllerGetGuestHomeDataApiResponse =
  /** status 200  User home data */ HomeDtoRead;
export type HomeControllerGetGuestHomeDataApiArg = void;
export type HomeControllerGetUserHomeDataApiResponse =
  /** status 200  User home data */ HomeDtoRead;
export type HomeControllerGetUserHomeDataApiArg = void;
export type HomeControllerGetCompleteRatesApiResponse = /** status 200  */ CompleteRatesDto;
export type HomeControllerGetCompleteRatesApiArg = void;
export type TaskControllerFindTasksByFiltersApiResponse =
  /** status 200 Tasks by filter and pagination */ TaskByFiltersResponseDtoRead;
export type TaskControllerFindTasksByFiltersApiArg = {
  page?: number;
  limit?: number;
  customer?: string;
  hideCustomer?: string;
  date?: string;
  platform?: string;
  action?: string;
  containsCompletedTasks?: boolean;
};
export type TaskControllerFindAmpTasksByFiltersApiResponse =
  /** status 200 Tasks by filter and pagination */ TaskByFiltersResponseDtoRead;
export type TaskControllerFindAmpTasksByFiltersApiArg = {
  page?: number;
  limit?: number;
  customer?: string;
  hideCustomer?: string;
  date?: string;
  platform?: string;
  action?: string;
  containsCompletedTasks?: boolean;
};
export type TaskControllerFindCompletedAmpTasksByFiltersApiResponse =
  /** status 200 Tasks by filter and pagination */ TaskByFiltersResponseDtoRead;
export type TaskControllerFindCompletedAmpTasksByFiltersApiArg = {
  page?: number;
  limit?: number;
  customer?: string;
  hideCustomer?: string;
  date?: string;
  platform?: string;
  action?: string;
  containsCompletedTasks?: boolean;
};
export type TaskControllerUpdateTaskSettingsApiResponse =
  /** status 200  Task type changed */ ResponseMessageDto;
export type TaskControllerUpdateTaskSettingsApiArg = {
  /** task key */
  type: string;
  updateTaskSettingsDto: UpdateTaskSettingsDto;
};
export type TaskControllerCreateApiResponse = /** status 201 Task created! */ ResponseIdDto;
export type TaskControllerCreateApiArg = TaskCreateDto;
export type TaskControllerFindAllApiResponse = /** status 200  */ PaginatedDto & {
  list?: TaskPublicDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type TaskControllerFindAllApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type TaskControllerFindPendingTaskApiResponse =
  /** status 200 Tasks by pending filter and pagination */ PendingTasksResponseDtoRead;
export type TaskControllerFindPendingTaskApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type TaskControllerFindOneApiResponse =
  /** status 200  Task info for users!  */ TaskPublicDtoRead;
export type TaskControllerFindOneApiArg = /** Mongo id */ string;
export type TaskControllerUpdateApiResponse = /** status 200  */ ResponseIdDto;
export type TaskControllerUpdateApiArg = {
  /** task ID */
  id: string;
  taskUpdateDto: TaskUpdateDto;
};
export type TaskControllerRemoveApiResponse = /** status 200  Task deleted!  */ ResponseMessageDto;
export type TaskControllerRemoveApiArg = /** task ID */ string;
export type TaskControllerVerifyTaskApiResponse =
  /** status 201  Task verified!  */ VerifyTaskResponseDto;
export type TaskControllerVerifyTaskApiArg = /** task ID */ string;
export type TaskControllerApproveTaskApiResponse =
  /** status 201  Approve task !  */ VerifyTaskResponseDto;
export type TaskControllerApproveTaskApiArg = {
  /** task ID */
  id: string;
  mongoDbIdDto: MongoDbIdDto;
};
export type TaskControllerUnApproveTaskApiResponse =
  /** status 201  Approve task !  */ VerifyTaskResponseDto;
export type TaskControllerUnApproveTaskApiArg = {
  /** task ID */
  id: string;
  mongoDbIdDto: MongoDbIdDto;
};
export type TaskControllerJoinTaskApiResponse =
  /** status 201  File uploaded!  */ VerifyTaskResponseDto;
export type TaskControllerJoinTaskApiArg = {
  /** Mongo id */
  id: string;
  body: {
    /** The file to upload */
    file?: Blob;
  };
};
export type TaskControllerGetTaskParticipantDataApiResponse =
  /** status 200  object of user information.  */ TaskParticipantDtoRead;
export type TaskControllerGetTaskParticipantDataApiArg = /** Mongo id */ string;
export type TaskControllerPauseApiResponse = /** status 201  */ ResponseIdDto;
export type TaskControllerPauseApiArg = /** Mongo id */ string;
export type TaskControllerActivateApiResponse = /** status 201  */ ResponseIdDto;
export type TaskControllerActivateApiArg = /** Mongo id */ string;
export type TaskControllerFindParticipantsApiResponse = /** status 200  */ PaginatedDto & {
  list?: TaskParticipantDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type TaskControllerFindParticipantsApiArg = {
  /** Mongo id */
  id: string;
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type CampaignControllerUpdateRewardsApiResponse = /** status 200  */ ResponseIdDto;
export type CampaignControllerUpdateRewardsApiArg = {
  /** campaign ID */
  id: string;
  campaignUpdateRewardsDto: CampaignUpdateRewardsDto;
};
export type CampaignControllerFindAllParticipantsByIdApiResponse =
  /** status 200  */ PaginatedDto & {
    list?: CampaignParticipantDtoRead[];
    meta?: PaginatedMetaDto;
    parent?: CampaignDtoRead;
  };
export type CampaignControllerFindAllParticipantsByIdApiArg = {
  /** Mongo id */
  id: string;
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type CampaignControllerFindAllPublicParticipantsByIdApiResponse =
  /** status 200  */ PaginatedDto & {
    list?: CampaignParticipantDtoRead[];
    meta?: PaginatedMetaDto;
    parent?: CampaignDtoRead;
  };
export type CampaignControllerFindAllPublicParticipantsByIdApiArg = {
  /** Mongo id */
  id: string;
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type CampaignControllerFindAllWinnersByIdApiResponse = /** status 201  */ PaginatedDto;
export type CampaignControllerFindAllWinnersByIdApiArg = {
  /** Mongo id */
  id: string;
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type CampaignControllerGetImageApiResponse = /** status 201  */ AvatarDto;
export type CampaignControllerGetImageApiArg = /** campaign ID */ string;
export type CampaignControllerUploadImageApiResponse = /** status 201  */ ResponseIdDto;
export type CampaignControllerUploadImageApiArg = {
  /** Mongo id */
  id: string;
  body: {
    /** The file to upload */
    file?: Blob;
  };
};
export type CampaignControllerFindAllTasksApiResponse = /** status 200  */ CampaignTaskDtoRead[];
export type CampaignControllerFindAllTasksApiArg = /** Mongo id */ string;
export type CampaignControllerUpsertTaskApiResponse = /** status 201  */ ResponseIdDto;
export type CampaignControllerUpsertTaskApiArg = {
  /** campaign ID */
  id: string;
  campaignTaskUpsertDto: CampaignTaskUpsertDto;
};
export type CampaignControllerRemoveTaskApiResponse = /** status 201  */ ResponseIdDto;
export type CampaignControllerRemoveTaskApiArg = {
  /** Mongo id */
  id: string;
  mongoDbIdDto: MongoDbIdDto;
};
export type CampaignControllerVerifyCampaignApiResponse = /** status 201  */ ResponseIdDto;
export type CampaignControllerVerifyCampaignApiArg = /** Mongo id */ string;
export type CampaignControllerPauseApiResponse = /** status 201  */ ResponseIdDto;
export type CampaignControllerPauseApiArg = /** Mongo id */ string;
export type CampaignControllerActivateApiResponse = /** status 201  */ ResponseIdDto;
export type CampaignControllerActivateApiArg = /** Mongo id */ string;
export type CampaignControllerWinnerApiResponse = /** status 201  */ ResponseIdDto;
export type CampaignControllerWinnerApiArg = {
  /** Mongo id */
  id: string;
  mongoDbIdDto: MongoDbIdDto;
};
export type CampaignControllerFindAllPublicApiResponse = /** status 200  */ PaginatedDto & {
  list?: CampaignUserDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type CampaignControllerFindAllPublicApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type CampaignControllerFindAllPublicWithAuthApiResponse = /** status 200  */ PaginatedDto & {
  list?: CampaignUserDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type CampaignControllerFindAllPublicWithAuthApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type CampaignControllerFindAllGuestWithAuthApiResponse = /** status 200  */ PaginatedDto & {
  list?: CampaignUserDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type CampaignControllerFindAllGuestWithAuthApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type CampaignControllerFindOnePublicApiResponse = /** status 200  */ CampaignUserDtoRead;
export type CampaignControllerFindOnePublicApiArg = /** Mongo id */ string;
export type CampaignControllerFindOneGuestApiResponse = /** status 200  */ CampaignUserDtoRead;
export type CampaignControllerFindOneGuestApiArg = /** Mongo id */ string;
export type CampaignControllerCreateApiResponse = /** status 201  */ ResponseIdDto;
export type CampaignControllerCreateApiArg = CampaignCreateDto;
export type CampaignControllerFindAllApiResponse = /** status 200  */ PaginatedDto & {
  list?: CampaignDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type CampaignControllerFindAllApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type CampaignControllerFindOneApiResponse = /** status 200  */ CampaignDtoRead;
export type CampaignControllerFindOneApiArg = /** Mongo id */ string;
export type CampaignControllerUpdateApiResponse = /** status 200  */ ResponseIdDto;
export type CampaignControllerUpdateApiArg = {
  /** campaign ID */
  id: string;
  campaignUpdateDto: CampaignUpdateDto;
};
export type CampaignControllerRemoveApiResponse = /** status 201  */ ResponseIdDto;
export type CampaignControllerRemoveApiArg = /** campaign ID */ string;
export type GiveawayControllerJoinApiResponse = /** status 201  */ ResponseIdDto;
export type GiveawayControllerJoinApiArg = {
  id: string;
  giveawayJoinDto: GiveawayJoinDto;
};
export type GiveawayControllerFindAllParticipantsByIdApiResponse =
  /** status 200  */ PaginatedDto & {
    list?: ProfileInfoDtoRead[];
    meta?: PaginatedMetaDto;
    parent?: GiveawayDtoRead;
  };
export type GiveawayControllerFindAllParticipantsByIdApiArg = {
  /** Mongo id */
  id: string;
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type GiveawayControllerFindAllWinnersByIdApiResponse = /** status 200  */ PaginatedDto & {
  list?: GiveawayWinnerDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: GiveawayDtoRead;
};
export type GiveawayControllerFindAllWinnersByIdApiArg = {
  /** Mongo id */
  id: string;
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type GiveawayControllerGetRewardsApiResponse =
  /** status 200 Giveaway Reward List */ GiveawayRewardResponseDto[];
export type GiveawayControllerGetRewardsApiArg = void;
export type GiveawayControllerSetWalletForRewardApiResponse =
  /** status 200 Wallet set for reward */ ResponseMessageDto;
export type GiveawayControllerSetWalletForRewardApiArg = UpdateWalletDto;
export type GiveawayControllerCronJobsApiResponse = /** status 200  */ void;
export type GiveawayControllerCronJobsApiArg = void;
export type GiveawayControllerPauseApiResponse = /** status 201  */ ResponseIdDto;
export type GiveawayControllerPauseApiArg = /** Mongo id */ string;
export type GiveawayControllerActivateApiResponse = /** status 201  */ ResponseIdDto;
export type GiveawayControllerActivateApiArg = /** Mongo id */ string;
export type GiveawayControllerFindAllPublicApiResponse =
  /** status 200  */ GiveawayHomepageDtoRead[];
export type GiveawayControllerFindAllPublicApiArg = void;
export type GiveawayControllerCreateApiResponse = /** status 201  */ ResponseIdDto;
export type GiveawayControllerCreateApiArg = GiveawayCreateDto;
export type GiveawayControllerFindAllApiResponse = /** status 200  */ PaginatedDto & {
  list?: GiveawayDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type GiveawayControllerFindAllApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type GiveawayControllerFindOneApiResponse = /** status 200  */ GiveawayDtoRead;
export type GiveawayControllerFindOneApiArg = string;
export type GiveawayControllerUpdateApiResponse = /** status 200  */ ResponseIdDto;
export type GiveawayControllerUpdateApiArg = {
  /** Mongo id */
  id: string;
  giveawayUpdateDto: GiveawayUpdateDto;
};
export type GiveawayControllerDeleteApiResponse = /** status 201  */ ResponseIdDto;
export type GiveawayControllerDeleteApiArg = string;
export type DailyRewardControllerGetActiveCampaignStatusApiResponse =
  /** status 200  */ DailyRewardStatusDtoRead;
export type DailyRewardControllerGetActiveCampaignStatusApiArg = void;
export type DailyRewardControllerClaimApiResponse =
  /** status 201 Claim success */ DailyRewardClaimDto;
export type DailyRewardControllerClaimApiArg = void;
export type DailyRewardControllerPauseApiResponse = /** status 201  */ ResponseIdDto;
export type DailyRewardControllerPauseApiArg = /** Mongo id */ string;
export type DailyRewardControllerActivateApiResponse = /** status 201  */ ResponseIdDto;
export type DailyRewardControllerActivateApiArg = /** Mongo id */ string;
export type DailyRewardControllerCreateApiResponse = /** status 201  */ ResponseIdDto;
export type DailyRewardControllerCreateApiArg = DailyCampaignCreateDto;
export type DailyRewardControllerFindAllApiResponse = /** status 200  */ PaginatedDto & {
  list?: DailyCampaignDtoRead[];
  meta?: PaginatedMetaDto;
  parent?: any;
};
export type DailyRewardControllerFindAllApiArg = {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
  role?: string;
};
export type DailyRewardControllerFindOneApiResponse = /** status 200  */ DailyCampaignDtoRead;
export type DailyRewardControllerFindOneApiArg = string;
export type DailyRewardControllerUpdateApiResponse = /** status 200  */ ResponseIdDto;
export type DailyRewardControllerUpdateApiArg = {
  /** Mongo id */
  id: string;
  dailyCampaignUpdateDto: DailyCampaignUpdateDto;
};
export type DailyRewardControllerDeleteApiResponse = /** status 201  */ ResponseIdDto;
export type DailyRewardControllerDeleteApiArg = string;
export type StatisticsControllerSummaryApiResponse = /** status 200  */ StatsSummaryDto;
export type StatisticsControllerSummaryApiArg = void;
export type StatisticsControllerSummaryPublicApiResponse = /** status 200  */ StatsSummaryPublicDto;
export type StatisticsControllerSummaryPublicApiArg = void;
export type StatisticsControllerUserAcquisitionApiResponse =
  /** status 200  */ UserAcquisitionDto[];
export type StatisticsControllerUserAcquisitionApiArg = void;
export type StatisticsControllerTaskInteractionDataApiResponse =
  /** status 200  */ TaskInteractionDto[];
export type StatisticsControllerTaskInteractionDataApiArg = void;
export type StatisticsControllerPointDistributionApiResponse =
  /** status 200  */ PointDistributionDto[];
export type StatisticsControllerPointDistributionApiArg = void;
export type StatisticsControllerUsersByLocationApiResponse = /** status 200  */ UserByLocationDto[];
export type StatisticsControllerUsersByLocationApiArg = void;
export type StatisticsControllerGetCustomerInfoApiResponse =
  /** status 200  */ StatsCustomerInfoDto;
export type StatisticsControllerGetCustomerInfoApiArg = void;
export type StatisticsControllerGetStatsGoogleApiResponse = /** status 200  */ ResponseMessageDto;
export type StatisticsControllerGetStatsGoogleApiArg = void;
export type MidleTasksControllerIsAccountConnectedApiResponse = /** status 200  */ boolean;
export type MidleTasksControllerIsAccountConnectedApiArg = {
  provider: string;
  userId: string;
};
export type MidleTasksControllerCheckRefCodeApiResponse = /** status 200  */ boolean;
export type MidleTasksControllerCheckRefCodeApiArg = {
  userId: string;
  taskCustomCheckDto: TaskCustomCheckDto;
};
export type ResponseMessageDto = {
  /** Response message */
  message: string;
};
export type ErrorDto = {
  status: number;
  name: string;
  message: string;
  timestamp: string;
  method: string;
  path: string;
  stack: string;
  validations: string[];
};
export type AuthDto = {
  /** The name of the User */
  name?: string;
  /** All roles of the user. */
  roles: string[];
  /** Session key */
  session: string;
  accessToken: string;
  refreshToken: string;
};
export type RegisterDto = {
  /** The name of the User */
  name?: string;
  /** The password of the user. */
  password: string;
  /** The unique username of the User */
  username: string;
  /** Referred by of user */
  referredBy?: string;
  /** The email of the User */
  email?: string;
  /** The phone of the user */
  phone?: string;
  /** Ref code */
  ref?: string;
};
export type LoginDto = {
  /** The password of the user. */
  password: string;
  /** The username, email or sms number of the User */
  username: string;
  /** This is for extending the refresh token time. */
  remember?: 0 | 1;
};
export type RefreshDto = {
  /** The name of the User */
  name?: string;
  /** All roles of the user. */
  roles: string[];
  /** Session key */
  session: string;
  accessToken: string;
  refreshToken: string;
};
export type Account = {
  provider: string;
  identity: string;
  isVerified: boolean;
  username: string;
};
export type RecoveryDto = {
  /** The email of the User */
  email?: string;
  /** The phone of the user */
  phone?: string;
};
export type ResetResponseDto = {
  /** The name of the User */
  name?: string;
  /** All roles of the user. */
  roles: string[];
  /** Session key */
  session: string;
  accessToken: string;
  refreshToken: string;
};
export type ResetPasswordDto = {
  /** The password of the user. */
  password: string;
};
export type Logout = {
  /** Logout status */
  status: boolean;
  /** Logout message */
  message: string;
};
export type UpdatePasswordDto = {
  /** The password of the user. */
  password?: string;
  /** The new password of the user. */
  newPassword: string;
};
export type UpdateUsernameDto = {
  /** The unique username of the User */
  username: string;
};
export type ClaimDto = {
  /** starter role of the user */
  role: string;
};
export type WalletLoginDto = {
  /** Ref code */
  ref?: string;
  /** Ethereum account address */
  accountAddress: string;
  /** Signature for message */
  signature: string;
  /** Message for login */
  message: string;
};
export type WalletLoginMessageDto = {
  /** Message for login */
  message: string;
};
export type SocialDisconnectDto = {
  id: string;
};
export type AuthorizeUrlDto = {
  url: string;
};
export type TwitterConnectDto = {
  token: string;
  /** Ref code */
  ref?: string;
  verifier: string;
};
export type BaseConnectDto = {
  token: string;
  /** Ref code */
  ref?: string;
};
export type TelegramConnectDto = {
  /** Ref code */
  ref?: string;
  name?: string;
  telegramId: number;
  photoUrl?: string;
  hash: string;
  authDate: number;
};
export type SteamConnectDto = {
  /** Ref code */
  ref?: string;
  steamId: string;
};
export type RedditConnectDto = {
  /** Ref code */
  ref?: string;
  code: string;
  state: string;
};
export type SpotifyConnectDto = {
  /** Ref code */
  ref?: string;
  code: string;
};
export type AppleLoginDto = {
  token: string;
  /** Apple ID */
  appleId: string;
  /** Apple nonce */
  nonce: string;
};
export type CosmosLoginDto = {
  /** Ref code */
  ref?: string;
  /** Ethereum account address */
  accountAddress: string;
  /** Signature for message */
  signature: string;
  /** Message for login */
  message: string;
  /** Signature public key for message */
  signaturePublicKey: string;
};
export type VerifyResponseDto = {
  /** The verify token */
  token: string;
};
export type VerifyDto = {
  /** The data will be verify. Email or Phone */
  data: string;
  /** Verification code */
  code: string;
  /** Type of token */
  type: 'recovery' | 'verify';
};
export type ResendDto = {
  /** The data will be verify. Email or Phone */
  data: string;
};
export type AccountDto = {
  provider: string;
  identity: string;
  isVerified: boolean;
  username: string;
};
export type AddAccountDto = {
  provider: string;
  identity: string;
};
export type VerifyAccountDto = {
  provider: string;
  identity: string;
};
export type UserDto = {
  /** The name of the User */
  name?: string;
  accounts: Account[];
  /** All roles of the user. */
  roles: string[];
  /** The unique username of the User */
  username: string;
  createdAt: string;
  /** Determines user is verified or not. */
  isVerified: boolean;
  /** It corresponds user is active or not. */
  isDeactivated: boolean;
  /** Referred by of user */
  referredBy?: string;
  /** The current count of accounts */
  connectedAccounts: number;
};
export type UserDtoRead = {
  /** The name of the User */
  name?: string;
  accounts: Account[];
  /** All roles of the user. */
  roles: string[];
  /** The unique username of the User */
  username: string;
  createdAt: string;
  /** Determines user is verified or not. */
  isVerified: boolean;
  /** It corresponds user is active or not. */
  isDeactivated: boolean;
  /** Referred by of user */
  referredBy?: string;
  /** The unique id */
  id: string;
  /** The current count of accounts */
  connectedAccounts: number;
};
export type CreateUserDto = {
  /** The name of the User */
  name?: string;
  /** The password of the user. */
  password: string;
  /** The unique username of the User */
  username: string;
  /** Referred by of user */
  referredBy?: string;
  /** The email of the User */
  email?: string;
  /** The phone of the user */
  phone?: string;
  /** Determines user is verified or not. */
  isVerified: boolean;
};
export type UpdateUserDto = {
  /** The name of the User */
  name?: string;
};
export type UpdateRolesDto = {
  /** All roles of the user. */
  roles: string[];
};
export type AvatarDto = {
  /** Image source */
  src: string;
  /** Avatar type */
  type: number;
};
export type ResponseStatusDto = {
  /** Response status as boolean */
  status: boolean;
};
export type ClanInfoDto = {
  /** Clan name */
  name: string;
  avatar?: AvatarDto;
};
export type ClanInfoDtoRead = {
  /** Clan name */
  name: string;
  avatar?: AvatarDto;
  leaderId: string;
  /** The unique id of Clan */
  id: string;
};
export type UserSemiPrivateDto = {
  /** The name of the User */
  name?: string;
  accounts: Account[];
  /** The unique username of the User */
  username: string;
  createdAt: string;
  /** Determines user is verified or not. */
  isVerified: boolean;
  /** It corresponds user is active or not. */
  isDeactivated: boolean;
  /** The current count of accounts */
  connectedAccounts: number;
};
export type UserSemiPrivateDtoRead = {
  /** The name of the User */
  name?: string;
  accounts: Account[];
  /** The unique username of the User */
  username: string;
  createdAt: string;
  /** Determines user is verified or not. */
  isVerified: boolean;
  /** It corresponds user is active or not. */
  isDeactivated: boolean;
  /** The unique id */
  id: string;
  /** The current count of accounts */
  connectedAccounts: number;
};
export type ProfileSemiPrivateDto = {
  /** currentXp */
  currentXp: number;
  avatar?: AvatarDto;
  /** currentTicket */
  currentTicket: number;
  clan?: ClanInfoDto;
  user: UserSemiPrivateDto;
};
export type ProfileSemiPrivateDtoRead = {
  /** currentXp */
  currentXp: number;
  avatar?: AvatarDto;
  /** currentTicket */
  currentTicket: number;
  clan?: ClanInfoDtoRead;
  /** The unique id */
  id: string;
  user: UserSemiPrivateDtoRead;
};
export type UserPrivateDto = {
  /** The name of the User */
  name?: string;
  accounts: Account[];
  /** All roles of the user. */
  roles: string[];
  /** The unique username of the User */
  username: string;
  createdAt: string;
  /** Determines user is verified or not. */
  isVerified: boolean;
  /** It corresponds user is active or not. */
  isDeactivated: boolean;
  /** The current count of accounts */
  connectedAccounts: number;
};
export type UserPrivateDtoRead = {
  /** The name of the User */
  name?: string;
  accounts: Account[];
  /** All roles of the user. */
  roles: string[];
  /** The unique username of the User */
  username: string;
  createdAt: string;
  /** Determines user is verified or not. */
  isVerified: boolean;
  /** It corresponds user is active or not. */
  isDeactivated: boolean;
  /** The unique id */
  id: string;
  /** The current count of accounts */
  connectedAccounts: number;
};
export type ProfilePrivateDto = {
  /** currentAmp */
  currentAmp: number;
  /** usedAmp */
  usedAmp: number;
  /** currentXp */
  currentXp: number;
  /** usedXp */
  usedXp: number;
  avatar?: AvatarDto;
  /** currentTicket */
  currentTicket: number;
  /** usedTicket */
  usedTicket: number;
  clan?: ClanInfoDto;
  /** totalXp */
  totalXp: number;
  /** totalTicket */
  totalTicket: number;
  user: UserPrivateDto;
  referredByCount: number;
};
export type ProfilePrivateDtoRead = {
  /** currentAmp */
  currentAmp: number;
  /** usedAmp */
  usedAmp: number;
  /** currentXp */
  currentXp: number;
  /** usedXp */
  usedXp: number;
  avatar?: AvatarDto;
  /** currentTicket */
  currentTicket: number;
  /** usedTicket */
  usedTicket: number;
  clan?: ClanInfoDtoRead;
  /** The unique id */
  id: string;
  /** totalXp */
  totalXp: number;
  /** totalTicket */
  totalTicket: number;
  user: UserPrivateDtoRead;
  referredByCount: number;
};
export type AddXpResponseDto = {
  currentXp: number;
};
export type AddXpDto = {
  /** Mongo id */
  id: string;
  xp: number;
};
export type AddTicketResponseDto = {
  currentTicket: number;
};
export type AddTicketDto = {
  /** Mongo id */
  id: string;
  ticket: number;
};
export type PaginatedMetaDto = {
  page: number;
  limit: number;
  total: number;
  item?: object;
};
export type PaginatedDto = {
  meta: PaginatedMetaDto;
  list: any[];
  parent?: object;
};
export type UserInfoDto = {
  /** The name of the User */
  name?: string;
  /** The unique username of the User */
  username: string;
  createdAt: string;
};
export type ProfileInfoDto = {
  /** currentXp */
  currentXp: number;
  avatar?: AvatarDto;
  clan?: ClanInfoDto;
  user: UserInfoDto;
};
export type ProfileInfoDtoRead = {
  /** currentXp */
  currentXp: number;
  avatar?: AvatarDto;
  clan?: ClanInfoDtoRead;
  /** The unique id */
  id: string;
  user: UserInfoDto;
};
export type FileDto = {
  /** File source */
  src: string;
  /** File type */
  type: number;
};
export type RelatedDto = {
  id: string;
  avatar?: AvatarDto;
  name?: string;
};
export type NotificationDto = {
  isSeen: boolean;
  type: 0 | 10 | 11 | 12 | 20 | 30 | 40 | 50 | 60 | 70;
  title: string;
  message: string;
  relatedType: 'Clan' | 'Profile' | 'Giveaway';
  createdAt: string;
  /** relatedId */
  related: RelatedDto;
};
export type NotificationDtoRead = {
  isSeen: boolean;
  type: 0 | 10 | 11 | 12 | 20 | 30 | 40 | 50 | 60 | 70;
  title: string;
  message: string;
  relatedType: 'Clan' | 'Profile' | 'Giveaway';
  createdAt: string;
  id: string;
  /** relatedId */
  related: RelatedDto;
};
export type NotificationResponseDto = {
  /** NotificationList array */
  list: NotificationDto[];
};
export type NotificationResponseDtoRead = {
  /** NotificationList array */
  list: NotificationDtoRead[];
};
export type NotificationIdListDto = {
  /** Notification id List array */
  list: string[];
};
export type LeaderboardMemberDto = {
  /** type of entity */
  entityType: 'user' | 'guild' | 'userInGuild';
  /** Id of user or guild */
  entityId: string;
  /** kullanıcının dateType içinde kazandığı total xp */
  xp: number;
  avgXPPerDay: number;
  name: string;
  image?: string;
  isVerified?: boolean;
  clan?: string;
  clanId?: string;
  members?: number;
  order: number;
};
export type LeaderboardResponseDto = {
  /** LeaderboardList array */
  list: LeaderboardMemberDto[];
  /** Entity by entityType */
  self?: LeaderboardMemberDto;
  /** Entity by entityType */
  entityCount: number;
};
export type ClanJoinRequestDto = {
  /** clan or user */
  requester: string;
  profile: ProfileInfoDto;
  clan: ClanInfoDto;
  message: string;
};
export type ClanJoinRequestDtoRead = {
  /** clan or user */
  requester: string;
  profile: ProfileInfoDtoRead;
  clan: ClanInfoDtoRead;
  message: string;
  /** The unique id of */
  id: string;
};
export type ResponseIdDto = {
  /** Response id as string */
  id: string;
};
export type ClanJoinRequestCreateDto = {
  /** clan or user */
  requester: string;
  message: string;
  clanId?: string;
  userId?: string;
};
export type LeaderboardActivityDto = {
  id: string;
  currentMonthXp: number;
  totalXp: number;
  hours: number;
  activityRating: string;
};
export type ClanMemberWithStatsDto = {
  joinedAt: string;
  profile: ProfileInfoDto;
  role: string;
  leaderboardActivity?: LeaderboardActivityDto;
};
export type ClanMemberWithStatsDtoRead = {
  joinedAt: string;
  profile: ProfileInfoDtoRead;
  role: string;
  leaderboardActivity?: LeaderboardActivityDto;
};
export type CreateClanDto = {
  /** Clan name */
  name: string;
  /** clan message */
  message?: string;
};
export type ClanRoleSettings = {
  role: string;
  removeUser: boolean;
  changeRole: boolean;
  invite: boolean;
};
export type ClanWithStatsDto = {
  /** Clan name */
  name: string;
  avatar?: AvatarDto;
  /** clan message */
  message?: string;
  /** is verified? */
  isVerified: boolean;
  roleSettings: ClanRoleSettings[];
  isJoinRequestSent?: boolean;
  joinRequestId?: string;
  isInvited?: boolean;
  inviteId?: string;
  invitedIds?: string[];
  leaderboardActivity?: LeaderboardActivityDto;
};
export type ClanWithStatsDtoRead = {
  /** Clan name */
  name: string;
  avatar?: AvatarDto;
  /** clan message */
  message?: string;
  /** is verified? */
  isVerified: boolean;
  leaderId: string;
  /** The unique id of Clan */
  id: string;
  roleSettings: ClanRoleSettings[];
  membersCount: number;
  isJoinRequestSent?: boolean;
  joinRequestId?: string;
  isInvited?: boolean;
  inviteId?: string;
  invitedIds?: string[];
  leaderboardActivity?: LeaderboardActivityDto;
};
export type UpdateClanDto = {
  /** clan message */
  message?: string;
  roleSettings?: ClanRoleSettings[];
};
export type CustomerStatsDto = {
  totalTasks: number;
  activeTasks: number;
  totalPoints: number;
  activePoints: number;
};
export type CustomerWithStatsDto = {
  description?: string;
  website?: string;
  twitter?: string;
  discord?: string;
  telegram?: string;
  youtube?: string;
  medium?: string;
  github?: string;
  profile: ProfileInfoDto;
  stats: CustomerStatsDto;
};
export type CustomerWithStatsDtoRead = {
  description?: string;
  website?: string;
  twitter?: string;
  discord?: string;
  telegram?: string;
  youtube?: string;
  medium?: string;
  github?: string;
  /** The unique id */
  id: string;
  profile: ProfileInfoDtoRead;
  stats: CustomerStatsDto;
};
export type CustomerAddBalanceDto = {
  amount: number;
};
export type CustomerCreateDto = {
  /** The name of the User */
  name?: string;
  /** The password of the user. */
  password: string;
  /** The unique username of the User */
  username: string;
  /** The email of the User */
  email?: string;
};
export type CustomerContactDto = {
  name?: string;
  email?: string;
  phone?: string;
  telegram?: string;
};
export type CustomerPrivateDto = {
  balance: number;
  description?: string;
  website?: string;
  contact?: CustomerContactDto;
  twitter?: string;
  discord?: string;
  telegram?: string;
  youtube?: string;
  medium?: string;
  github?: string;
  profile: ProfileInfoDto;
};
export type CustomerPrivateDtoRead = {
  balance: number;
  description?: string;
  website?: string;
  contact?: CustomerContactDto;
  twitter?: string;
  discord?: string;
  telegram?: string;
  youtube?: string;
  medium?: string;
  github?: string;
  /** The unique id */
  id: string;
  profile: ProfileInfoDtoRead;
};
export type ProfileCustomerDto = {
  /** currentXp */
  currentXp: number;
  avatar?: AvatarDto;
  clan?: ClanInfoDto;
  user: UserInfoDto;
  customer: CustomerPrivateDto;
  roles: string[];
};
export type ProfileCustomerDtoRead = {
  /** currentXp */
  currentXp: number;
  avatar?: AvatarDto;
  clan?: ClanInfoDtoRead;
  /** The unique id */
  id: string;
  user: UserInfoDto;
  customer: CustomerPrivateDtoRead;
  roles: string[];
};
export type CustomerUpdateDto = {
  /** The name of the User */
  name?: string;
  description?: string;
  website?: string;
  contact?: CustomerContactDto;
  twitter?: string;
  discord?: string;
  telegram?: string;
  youtube?: string;
  medium?: string;
  github?: string;
};
export type LanguageDto = {
  /** The English language text */
  en?: string;
  /** The Turkish language text */
  tr?: string;
  /** The French language text */
  fr?: string;
};
export type ProvidersTypes = {
  /** The platform on which the action will be performed */
  platform: string;
  /** The title to be performed on the platform */
  title: LanguageDto;
  /** Minimum xp to be gained when the task is completed. */
  minXp: number;
  /** name of provider type */
  type: string;
};
export type ProvidersDto = {
  /** Providers all platforms */
  platforms: string[];
  /** Providers */
  providers: string[];
  /** Providers all enums */
  types: ProvidersTypes[];
  /** Providers all actions */
  actions: string[];
};
export type OptionDto = {
  value: string;
  /** Value label */
  label: string;
};
export type TitlesDto = {
  platforms: {
    [key: string]: string;
  };
  taskStatus: {
    [key: string]: string;
  };
};
export type InitData = {
  /** Providers */
  providers: ProvidersDto;
  /** statuses */
  statuses: OptionDto[];
  provider: OptionDto[];
  platforms: OptionDto[];
  chains: OptionDto[];
  titles: TitlesDto;
};
export type SelfDto = {
  profile: ProfilePrivateDto;
  customer?: CustomerPrivateDto;
};
export type SelfDtoRead = {
  profile: ProfilePrivateDtoRead;
  customer?: CustomerPrivateDtoRead;
};
export type CustomerDto = {
  balance: number;
  description?: string;
  website?: string;
  twitter?: string;
  discord?: string;
  telegram?: string;
  youtube?: string;
  medium?: string;
  github?: string;
  profile: ProfileInfoDto;
};
export type CustomerDtoRead = {
  balance: number;
  description?: string;
  website?: string;
  twitter?: string;
  discord?: string;
  telegram?: string;
  youtube?: string;
  medium?: string;
  github?: string;
  /** The unique id */
  id: string;
  profile: ProfileInfoDtoRead;
};
export type AwardsDto = {
  /** Type of the gain */
  type: string;
  /** The amount of the gain */
  amount: number;
};
export type CampaignUserDto = {
  customer: CustomerDto;
  /** The title of the task in English and Turkish */
  title: LanguageDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The date and time when the task starts */
  startDate: string;
  /** The date and time when the task ends */
  endDate: string;
  /** The maximum number of participants allowed in the task */
  participantsLimit: number;
  /** Winners count */
  winnersLimit: number;
  tasks: any[];
  /** An array of gain objects for campaign completed */
  awards: AwardsDto[];
  image: AvatarDto;
  /** Sort order */
  priority?: number;
  status: string;
  createdBy: ProfileInfoDto;
  completedTaskIds: string[];
  isCampaignCompleted: boolean;
};
export type CampaignUserDtoRead = {
  customer: CustomerDtoRead;
  /** The title of the task in English and Turkish */
  title: LanguageDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The date and time when the task starts */
  startDate: string;
  /** The date and time when the task ends */
  endDate: string;
  /** The maximum number of participants allowed in the task */
  participantsLimit: number;
  /** Winners count */
  winnersLimit: number;
  tasks: any[];
  /** An array of gain objects for campaign completed */
  awards: AwardsDto[];
  image: AvatarDto;
  /** The unique id of Giveaway */
  id: string;
  /** The current count of participants */
  participantsCount: number;
  winnersCount: number;
  /** Sort order */
  priority?: number;
  status: string;
  createdBy: ProfileInfoDtoRead;
  completedTaskIds: string[];
  isCampaignCompleted: boolean;
};
export type TaskPublicDto = {
  customer: CustomerDto;
  /** The title of the task in English and Turkish */
  title: LanguageDto;
  /** optional task avatar */
  avatar?: AvatarDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The platform on which the task is hosted */
  platform?: string;
  /** The provider to perform task */
  provider?:
    | 'midle'
    | 'midleWeb3'
    | 'twitter'
    | 'discord'
    | 'telegram'
    | 'github'
    | 'spotify'
    | 'tiktok'
    | 'custom'
    | 'wallet'
    | 'nibiru'
    | 'google'
    | 'youtube'
    | 'facebook'
    | 'instagram'
    | 'OnChain'
    | 'reddit'
    | 'steam'
    | 'apple'
    | 'gitcoin'
    | 'other';
  /** The action on type which is related with task */
  action: string;
  /** The number of seconds to wait for verification after a participant completes an task */
  verifyTime?: number;
  /** The date and time when the task starts */
  startDate: string;
  /** The date and time when the task ends */
  endDate: string;
  /** The maximum number of participants allowed in the task */
  participantsLimit: number;
  /** The title of the task in English and Turkish */
  visitUrl?: string;
  /** Task check url */
  checkUrl?: string;
  data?: {
    [key: string]: string | boolean | number;
  };
  /** The current count of participants */
  participantsCount: number;
  /** The amount of XP that can be earned through the task */
  xp: number;
  /** The amount of AMP that can be earned through the task */
  amp: number;
  isVisible?: boolean;
  /** Task status */
  status: string;
};
export type TaskPublicDtoRead = {
  customer: CustomerDtoRead;
  /** The title of the task in English and Turkish */
  title: LanguageDto;
  /** optional task avatar */
  avatar?: AvatarDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The platform on which the task is hosted */
  platform?: string;
  /** The provider to perform task */
  provider?:
    | 'midle'
    | 'midleWeb3'
    | 'twitter'
    | 'discord'
    | 'telegram'
    | 'github'
    | 'spotify'
    | 'tiktok'
    | 'custom'
    | 'wallet'
    | 'nibiru'
    | 'google'
    | 'youtube'
    | 'facebook'
    | 'instagram'
    | 'OnChain'
    | 'reddit'
    | 'steam'
    | 'apple'
    | 'gitcoin'
    | 'other';
  /** The action on type which is related with task */
  action: string;
  /** The number of seconds to wait for verification after a participant completes an task */
  verifyTime?: number;
  /** The date and time when the task starts */
  startDate: string;
  /** The date and time when the task ends */
  endDate: string;
  /** The maximum number of participants allowed in the task */
  participantsLimit: number;
  /** The title of the task in English and Turkish */
  visitUrl?: string;
  /** Task check url */
  checkUrl?: string;
  data?: {
    [key: string]: string | boolean | number;
  };
  /** The current count of participants */
  participantsCount: number;
  /** The amount of XP that can be earned through the task */
  xp: number;
  /** The amount of AMP that can be earned through the task */
  amp: number;
  isVisible?: boolean;
  /** The unique id of task */
  id: string;
  /** Task status */
  status: string;
};
export type TaskByFiltersResponseDto = {
  /** task list */
  list: TaskPublicDto[];
  total: number;
};
export type TaskByFiltersResponseDtoRead = {
  /** task list */
  list: TaskPublicDtoRead[];
  total: number;
};
export type GiveawayHomepageDto = {
  /** The title of the Giveaway in English and Turkish */
  title: LanguageDto;
  /** The description of the Giveaway */
  description: LanguageDto;
  /** The tag of the Giveaway by admin page */
  tag: string;
  /** A theme of Giveaway Component for UI */
  theme?: string;
  /** The start date of the giveaway */
  startDate: string;
  /** The end date of the giveaway */
  endDate: string;
  /** Total reward of Giveaway to distribute */
  totalReward: number;
  /** Total winner count of Giveaway */
  winnersLimit: number;
  /** Total reward token type */
  rewardToken: string;
  /** Total used ticket for Giveaway */
  ticketUsed: number;
  /** Minimum XP to join Giveaway */
  minXP: number;
  /** Is connected metamask */
  metamaskRequired: boolean;
  /** Total number of participants */
  participantCount: number;
  /** Winners username for giveaway */
  winners?: ProfileInfoDto[];
  /** Joined tickets */
  joinedTickets: number;
};
export type GiveawayHomepageDtoRead = {
  /** The title of the Giveaway in English and Turkish */
  title: LanguageDto;
  /** The description of the Giveaway */
  description: LanguageDto;
  /** The tag of the Giveaway by admin page */
  tag: string;
  /** A theme of Giveaway Component for UI */
  theme?: string;
  /** The start date of the giveaway */
  startDate: string;
  /** The end date of the giveaway */
  endDate: string;
  /** Total reward of Giveaway to distribute */
  totalReward: number;
  /** Total winner count of Giveaway */
  winnersLimit: number;
  /** Total reward token type */
  rewardToken: string;
  /** Total used ticket for Giveaway */
  ticketUsed: number;
  /** Minimum XP to join Giveaway */
  minXP: number;
  /** Is connected metamask */
  metamaskRequired: boolean;
  /** The unique id of Giveaway */
  id: string;
  winnersCount: number;
  /** Total number of participants */
  participantCount: number;
  /** Winners username for giveaway */
  winners?: ProfileInfoDtoRead[];
  /** Joined tickets */
  joinedTickets: number;
};
export type HomeDto = {
  /** Campaigns list */
  campaigns: CampaignUserDto[];
  /** main tasks in ui */
  mainTasks: TaskByFiltersResponseDto;
  /** left tasks in ui */
  leftTasks: TaskByFiltersResponseDto;
  /** right tasks in ui */
  rightTasks: TaskByFiltersResponseDto;
  /** pending tasks in ui */
  pendingTasks: string[];
  /** user leaderboard */
  userLeaderboard: LeaderboardResponseDto;
  /** guild leaderboard */
  guildLeaderboard: LeaderboardResponseDto;
  /** previous month user leaderboard */
  prevUserLeaderboard: LeaderboardResponseDto;
  /** previous month guild leaderboard */
  prevGuildLeaderboard: LeaderboardResponseDto;
  /** left giveaway */
  leftGiveaway?: GiveawayHomepageDto;
  /** right giveaway */
  rightGiveaway?: GiveawayHomepageDto;
  /** left last giveaway with reward */
  leftLastGiveawayWithRewards?: GiveawayHomepageDto;
  /** right last giveaway with reward */
  rightLastGiveawayWithRewards?: GiveawayHomepageDto;
  customers?: CustomerWithStatsDto[];
};
export type HomeDtoRead = {
  /** Campaigns list */
  campaigns: CampaignUserDtoRead[];
  /** main tasks in ui */
  mainTasks: TaskByFiltersResponseDtoRead;
  /** left tasks in ui */
  leftTasks: TaskByFiltersResponseDtoRead;
  /** right tasks in ui */
  rightTasks: TaskByFiltersResponseDtoRead;
  /** pending tasks in ui */
  pendingTasks: string[];
  /** user leaderboard */
  userLeaderboard: LeaderboardResponseDto;
  /** guild leaderboard */
  guildLeaderboard: LeaderboardResponseDto;
  /** previous month user leaderboard */
  prevUserLeaderboard: LeaderboardResponseDto;
  /** previous month guild leaderboard */
  prevGuildLeaderboard: LeaderboardResponseDto;
  /** left giveaway */
  leftGiveaway?: GiveawayHomepageDtoRead;
  /** right giveaway */
  rightGiveaway?: GiveawayHomepageDtoRead;
  /** left last giveaway with reward */
  leftLastGiveawayWithRewards?: GiveawayHomepageDtoRead;
  /** right last giveaway with reward */
  rightLastGiveawayWithRewards?: GiveawayHomepageDtoRead;
  customers?: CustomerWithStatsDtoRead[];
};
export type CompleteRatesDto = {
  connectionCompleted: number;
  connectionCount: number;
  tasksCompleted: number;
  tasksCount: number;
  campaignCompleted: number;
  campaignCount: number;
};
export type UpdateTaskSettingsDto = {
  /** Minimum xp to be gained when the task is completed. */
  minXp: number;
};
export type TaskCreateDto = {
  /** The title of the task in English and Turkish */
  title: LanguageDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The platform on which the task is hosted */
  platform?: string;
  /** The date and time when the task starts */
  startDate: string;
  /** The date and time when the task ends */
  endDate: string;
  /** The maximum number of participants allowed in the task */
  participantsLimit: number;
  /** The title of the task in English and Turkish */
  visitUrl?: string;
  /** Task check url */
  checkUrl?: string;
  data?: {
    [key: string]: string | boolean | number;
  };
  /** The amount of XP that can be earned through the task */
  xp: number;
  isVisible?: boolean;
  customerId?: string;
  type: string;
};
export type PendingTasksDto = {
  createdAt: string;
  profile: ProfileInfoDto;
  data: object;
  customer?: CustomerDto;
  /** The title of the task in English and Turkish */
  title?: LanguageDto;
  /** The platform on which the task is hosted */
  platform?: string;
  /** The action on type which is related with task */
  action?: string;
  /** The amount of XP that can be earned through the task */
  xp?: number;
  userId: string;
  participantUsername: string;
};
export type PendingTasksDtoRead = {
  createdAt: string;
  profile: ProfileInfoDtoRead;
  data: object;
  customer?: CustomerDtoRead;
  /** The title of the task in English and Turkish */
  title?: LanguageDto;
  /** The platform on which the task is hosted */
  platform?: string;
  /** The action on type which is related with task */
  action?: string;
  /** The amount of XP that can be earned through the task */
  xp?: number;
  /** The unique id of task */
  id?: string;
  userId: string;
  participantUsername: string;
};
export type PendingTasksResponseDto = {
  /** task list */
  list: PendingTasksDto[];
  total: number;
};
export type PendingTasksResponseDtoRead = {
  /** task list */
  list: PendingTasksDtoRead[];
  total: number;
};
export type TaskUpdateDto = {
  /** The title of the task in English and Turkish */
  title?: LanguageDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The platform on which the task is hosted */
  platform?: string;
  /** The date and time when the task starts */
  startDate?: string;
  /** The date and time when the task ends */
  endDate?: string;
  /** The maximum number of participants allowed in the task */
  participantsLimit?: number;
  /** The title of the task in English and Turkish */
  visitUrl?: string;
  /** Task check url */
  checkUrl?: string;
  data?: {
    [key: string]: string | boolean | number;
  };
  /** The amount of XP that can be earned through the task */
  xp?: number;
  isVisible?: boolean;
  customerId?: string;
};
export type VerifyTaskResponseDto = {
  /** Response message */
  message: string;
  /** true | false | progress */
  result: string;
};
export type MongoDbIdDto = {
  /** Mongo id */
  id: string;
};
export type TaskParticipantDto = {
  createdAt: string;
  profile: ProfileInfoDto;
  data: object;
};
export type TaskParticipantDtoRead = {
  createdAt: string;
  profile: ProfileInfoDtoRead;
  data: object;
};
export type CampaignUpdateRewardsDto = {
  /** The maximum number of participants allowed in the task */
  participantsLimit: number;
  /** Winners count */
  winnersLimit: number;
  /** An array of gain objects for campaign completed */
  awards: AwardsDto[];
};
export type CampaignParticipantDto = {
  /** currentXp */
  currentXp: number;
  avatar?: AvatarDto;
  clan?: ClanInfoDto;
  user: UserInfoDto;
  isWinner: boolean;
};
export type CampaignParticipantDtoRead = {
  /** currentXp */
  currentXp: number;
  avatar?: AvatarDto;
  clan?: ClanInfoDtoRead;
  /** The unique id */
  id: string;
  user: UserInfoDto;
  isWinner: boolean;
};
export type CampaignDto = {
  customer: CustomerDto;
  /** The title of the task in English and Turkish */
  title: LanguageDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The date and time when the task starts */
  startDate: string;
  /** The date and time when the task ends */
  endDate: string;
  /** The maximum number of participants allowed in the task */
  participantsLimit: number;
  /** Winners count */
  winnersLimit: number;
  tasks: any[];
  /** An array of gain objects for campaign completed */
  awards: AwardsDto[];
  image: AvatarDto;
  /** Sort order */
  priority?: number;
  status: string;
  createdBy: ProfileInfoDto;
};
export type CampaignDtoRead = {
  customer: CustomerDtoRead;
  /** The title of the task in English and Turkish */
  title: LanguageDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The date and time when the task starts */
  startDate: string;
  /** The date and time when the task ends */
  endDate: string;
  /** The maximum number of participants allowed in the task */
  participantsLimit: number;
  /** Winners count */
  winnersLimit: number;
  tasks: any[];
  /** An array of gain objects for campaign completed */
  awards: AwardsDto[];
  image: AvatarDto;
  /** The unique id of Giveaway */
  id: string;
  /** The current count of participants */
  participantsCount: number;
  winnersCount: number;
  /** Sort order */
  priority?: number;
  status: string;
  createdBy: ProfileInfoDtoRead;
};
export type CampaignTaskDto = {
  /** The title of the task in English and Turkish */
  title: LanguageDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The platform on which the task is hosted */
  platform?: string;
  /** The provider to perform task */
  provider?:
    | 'midle'
    | 'midleWeb3'
    | 'twitter'
    | 'discord'
    | 'telegram'
    | 'github'
    | 'spotify'
    | 'tiktok'
    | 'custom'
    | 'wallet'
    | 'nibiru'
    | 'google'
    | 'youtube'
    | 'facebook'
    | 'instagram'
    | 'OnChain'
    | 'reddit'
    | 'steam'
    | 'apple'
    | 'gitcoin'
    | 'other';
  /** The action on type which is related with task */
  action: string;
  /** The title of the task in English and Turkish */
  visitUrl?: string;
  /** Task check url */
  checkUrl?: string;
  data?: {
    [key: string]: string | boolean | number;
  };
  /** The amount of XP that can be earned through the task */
  xp: number;
};
export type CampaignTaskDtoRead = {
  /** The title of the task in English and Turkish */
  title: LanguageDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The platform on which the task is hosted */
  platform?: string;
  /** The provider to perform task */
  provider?:
    | 'midle'
    | 'midleWeb3'
    | 'twitter'
    | 'discord'
    | 'telegram'
    | 'github'
    | 'spotify'
    | 'tiktok'
    | 'custom'
    | 'wallet'
    | 'nibiru'
    | 'google'
    | 'youtube'
    | 'facebook'
    | 'instagram'
    | 'OnChain'
    | 'reddit'
    | 'steam'
    | 'apple'
    | 'gitcoin'
    | 'other';
  /** The action on type which is related with task */
  action: string;
  /** The title of the task in English and Turkish */
  visitUrl?: string;
  /** Task check url */
  checkUrl?: string;
  data?: {
    [key: string]: string | boolean | number;
  };
  /** The amount of XP that can be earned through the task */
  xp: number;
  /** The unique id of task */
  id: string;
};
export type CampaignTaskUpsertDto = {
  /** The title of the task in English and Turkish */
  title: LanguageDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The platform on which the task is hosted */
  platform?: string;
  /** The title of the task in English and Turkish */
  visitUrl?: string;
  /** Task check url */
  checkUrl?: string;
  data?: {
    [key: string]: string | boolean | number;
  };
  /** The amount of XP that can be earned through the task */
  xp: number;
  isVisible?: boolean;
  type: string;
  id?: string;
};
export type CampaignCreateDto = {
  /** The title of the task in English and Turkish */
  title: LanguageDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The date and time when the task starts */
  startDate: string;
  /** The date and time when the task ends */
  endDate: string;
  isVisible?: boolean;
  /** Optional customerId. Is required as Admin. */
  customer?: string;
  /** Optional id. */
  id?: string;
};
export type CampaignUpdateDto = {
  /** The title of the task in English and Turkish */
  title?: LanguageDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The date and time when the task starts */
  startDate?: string;
  /** The date and time when the task ends */
  endDate?: string;
  isVisible?: boolean;
  /** Optional id. */
  id?: string;
};
export type GiveawayJoinDto = {
  /** How many tickets will you attend? */
  tickets: number;
};
export type GiveawayDto = {
  /** The title of the Giveaway in English and Turkish */
  title: LanguageDto;
  /** The description of the Giveaway */
  description: LanguageDto;
  /** The tag of the Giveaway by admin page */
  tag: string;
  /** A theme of Giveaway Component for UI */
  theme?: string;
  /** The start date of the giveaway */
  startDate: string;
  /** The end date of the giveaway */
  endDate: string;
  /** Total reward of Giveaway to distribute */
  totalReward: number;
  /** the priority of giveaway to sort in page */
  priority: number;
  /** Total winner count of Giveaway */
  winnersLimit: number;
  /** Total reward token type */
  rewardToken: string;
  /** Minimum XP to join Giveaway */
  minXP: number;
  /** Is connected metamask */
  metamaskRequired: boolean;
  status: string;
  createdBy: ProfileInfoDto;
};
export type GiveawayDtoRead = {
  /** The title of the Giveaway in English and Turkish */
  title: LanguageDto;
  /** The description of the Giveaway */
  description: LanguageDto;
  /** The tag of the Giveaway by admin page */
  tag: string;
  /** A theme of Giveaway Component for UI */
  theme?: string;
  /** The start date of the giveaway */
  startDate: string;
  /** The end date of the giveaway */
  endDate: string;
  /** Total reward of Giveaway to distribute */
  totalReward: number;
  /** the priority of giveaway to sort in page */
  priority: number;
  /** Total winner count of Giveaway */
  winnersLimit: number;
  /** Total reward token type */
  rewardToken: string;
  /** Minimum XP to join Giveaway */
  minXP: number;
  /** Is connected metamask */
  metamaskRequired: boolean;
  /** The unique id of Giveaway */
  id: string;
  /** The current count of participants */
  participantsCount: number;
  winnersCount: number;
  status: string;
  createdBy: ProfileInfoDtoRead;
};
export type GiveawayWinnerDto = {
  /** Id of Giveaway */
  giveawayId: string;
  /** Id of User */
  userId: string;
  /** Specific wallet of User To Take Reward */
  wallet: string;
  /** Reward of Giveaway for related user */
  reward: number;
  /** Used ticket for giveaway participants */
  usedTicket: number;
  /** Did reward distributed by admin ? */
  rewardDistributed: boolean;
  profile: ProfileInfoDto;
};
export type GiveawayWinnerDtoRead = {
  /** Id of Giveaway */
  giveawayId: string;
  /** Id of User */
  userId: string;
  /** Specific wallet of User To Take Reward */
  wallet: string;
  /** Reward of Giveaway for related user */
  reward: number;
  /** Used ticket for giveaway participants */
  usedTicket: number;
  /** Did reward distributed by admin ? */
  rewardDistributed: boolean;
  /** The unique id */
  id: string;
  profile: ProfileInfoDtoRead;
};
export type GiveawayRewardResponseDto = {
  /** The title of the Giveaway in English and Turkish */
  title: LanguageDto;
  /** Total reward token type */
  rewardToken: string;
  /** Specific wallet of User To Take Reward */
  wallet: string;
  /** Reward of Giveaway for related user */
  reward: number;
  /** Did reward distributed by admin ? */
  rewardDistributed: boolean;
  /** Id of Reward */
  rewardId: string;
};
export type UpdateWalletDto = {
  /** Specific wallet of User To Take Reward */
  wallet: string;
  /** Id of Reward */
  rewardId: string;
};
export type GiveawayCreateDto = {
  /** The title of the Giveaway in English and Turkish */
  title: LanguageDto;
  /** The description of the Giveaway */
  description: LanguageDto;
  /** The tag of the Giveaway by admin page */
  tag: string;
  /** A theme of Giveaway Component for UI */
  theme?: string;
  /** The start date of the giveaway */
  startDate: string;
  /** The end date of the giveaway */
  endDate: string;
  /** Total reward of Giveaway to distribute */
  totalReward: number;
  /** the priority of giveaway to sort in page */
  priority: number;
  /** Total winner count of Giveaway */
  winnersLimit: number;
  /** Total reward token type */
  rewardToken: string;
  /** Minimum XP to join Giveaway */
  minXP: number;
  /** Is connected metamask */
  metamaskRequired: boolean;
};
export type GiveawayUpdateDto = {
  /** The title of the Giveaway in English and Turkish */
  title?: LanguageDto;
  /** The description of the Giveaway */
  description?: LanguageDto;
  /** The tag of the Giveaway by admin page */
  tag?: string;
  /** A theme of Giveaway Component for UI */
  theme?: string;
  /** The start date of the giveaway */
  startDate?: string;
  /** The end date of the giveaway */
  endDate?: string;
  /** Total reward of Giveaway to distribute */
  totalReward?: number;
  /** the priority of giveaway to sort in page */
  priority?: number;
  /** Total winner count of Giveaway */
  winnersLimit?: number;
  /** Total reward token type */
  rewardToken?: string;
  /** Minimum XP to join Giveaway */
  minXP?: number;
  /** Is connected metamask */
  metamaskRequired?: boolean;
};
export type DailyRewardType = 'xp' | 'ticket' | 'custom';
export type DailyRewardStatus = 'available' | 'claimed' | 'passed';
export type DailyRewardDto = {
  name: string;
  type: DailyRewardType;
  amount: number;
  status?: DailyRewardStatus;
};
export type DailyCampaignDto = {
  /** The title of the Giveaway in English and Turkish */
  title: LanguageDto;
  /** The description of the Giveaway */
  description?: LanguageDto;
  /** The start date of the giveaway */
  startDate: string;
  /** The end date of the giveaway */
  endDate: string;
  rewards: DailyRewardDto[];
  isVisible?: boolean;
  status: string;
};
export type DailyCampaignDtoRead = {
  /** The title of the Giveaway in English and Turkish */
  title: LanguageDto;
  /** The description of the Giveaway */
  description?: LanguageDto;
  /** The start date of the giveaway */
  startDate: string;
  /** The end date of the giveaway */
  endDate: string;
  rewards: DailyRewardDto[];
  isVisible?: boolean;
  /** The unique id of Giveaway */
  id: string;
  status: string;
};
export type DailyRewardStatusDto = {
  campaign?: DailyCampaignDto;
  day: number;
  claims: number;
  isAvailableToday: boolean;
  daysInMonth: number;
};
export type DailyRewardStatusDtoRead = {
  campaign?: DailyCampaignDtoRead;
  day: number;
  claims: number;
  isAvailableToday: boolean;
  daysInMonth: number;
};
export type DailyRewardClaimDto = {
  rewards?: DailyRewardDto[];
  success: boolean;
  day: number;
  claims: number;
};
export type DailyCampaignCreateDto = {
  /** The title of the Giveaway in English and Turkish */
  title: LanguageDto;
  /** The description of the Giveaway */
  description?: LanguageDto;
  /** The start date of the giveaway */
  startDate: string;
  /** The end date of the giveaway */
  endDate: string;
  rewards: DailyRewardDto[];
  isVisible?: boolean;
};
export type DailyCampaignUpdateDto = {
  /** The title of the Giveaway in English and Turkish */
  title?: LanguageDto;
  /** The description of the Giveaway */
  description?: LanguageDto;
  /** The start date of the giveaway */
  startDate?: string;
  /** The end date of the giveaway */
  endDate?: string;
  rewards?: DailyRewardDto[];
  isVisible?: boolean;
};
export type StatsSummaryDto = {
  totalUsers: number;
  monthlyVisits: number;
  activeDailyUsers: number;
  activeUsers: number;
  totalCustomers: number;
  usersNoXP: number;
  users01000XP: number;
  users10002000XP: number;
  usersOver2000XP: number;
  totalCompletedTask: number;
  task_view: number;
  task_complete: number;
  task_click: number;
  totalCompletedUserTaskCount: number;
  activeCustomers: number;
};
export type StatsSummaryPublicDto = {
  totalCustomers: number;
  countryCount: number;
  totalCompletedTask: number;
  totalXP: string;
};
export type UserAcquisitionDto = {
  date: string;
  userCount: number;
};
export type TaskInteractionDataDto = {
  taskId: string;
  eventName: string;
  eventCount: number;
};
export type TaskInteractionDto = {
  dataList: TaskInteractionDataDto[];
  date: string;
};
export type PointDistributionDataDto = {
  platform: string;
  action: string;
  eventCount: number;
  sumOfPoint: number;
};
export type PointDistributionDto = {
  taskId: string;
  dataList: PointDistributionDataDto[];
  date: string;
};
export type UserByLocationDto = {
  country: string;
  countryId: string;
  userCount: number;
};
export type StatsCustomerInfoDto = {
  peakDay: string;
  peakDayCompletedTaskCount: number;
  pointSpentAllTime: number;
  avgPointPerUser: string;
};
export type TaskCustomCheckDto = {
  /** The title of the task in English and Turkish */
  title: LanguageDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The number of seconds to wait for verification after a participant completes an task */
  verifyTime?: number;
  /** The date and time when the task starts */
  startDate: string;
  /** The date and time when the task ends */
  endDate: string;
  /** The maximum number of participants allowed in the task */
  participantsLimit: number;
  data?: {
    [key: string]: string | boolean | number;
  };
  /** The current count of participants */
  participantsCount: number;
  /** The amount of XP that can be earned through the task */
  xp: number;
};
export type TaskCustomCheckDtoRead = {
  /** The title of the task in English and Turkish */
  title: LanguageDto;
  /** The description of the promotion in English and Turkish */
  description?: LanguageDto;
  /** The number of seconds to wait for verification after a participant completes an task */
  verifyTime?: number;
  /** The date and time when the task starts */
  startDate: string;
  /** The date and time when the task ends */
  endDate: string;
  /** The maximum number of participants allowed in the task */
  participantsLimit: number;
  data?: {
    [key: string]: string | boolean | number;
  };
  /** The current count of participants */
  participantsCount: number;
  /** The amount of XP that can be earned through the task */
  xp: number;
  /** The unique id of task */
  id: string;
};
export const {
  useAppControllerGetTestQuery,
  useLazyAppControllerGetTestQuery,
  useAppControllerGetTime2Query,
  useLazyAppControllerGetTime2Query,
  useAppControllerGetTime1Query,
  useLazyAppControllerGetTime1Query,
  useAppControllerGetTime3Query,
  useLazyAppControllerGetTime3Query,
  useAppControllerGetVersionQuery,
  useLazyAppControllerGetVersionQuery,
  useAuthControllerRemoveMutation,
  useAuthControllerRegisterMutation,
  useAuthControllerLoginMutation,
  useAuthControllerRefreshMutation,
  useAuthControllerUnVerifiedAccountsQuery,
  useLazyAuthControllerUnVerifiedAccountsQuery,
  useAuthControllerVerifyMutation,
  useAuthControllerRecoveryMutation,
  useAuthControllerResetMutation,
  useAuthControllerLogoutMutation,
  useAuthControllerChangePasswordMutation,
  useAuthControllerSetUsernameMutation,
  useAuthControllerClaimMutation,
  useWalletControllerAuthenticateMutation,
  useWalletControllerGetMetamaskLoginMessageQuery,
  useLazyWalletControllerGetMetamaskLoginMessageQuery,
  useWalletControllerDisconnectWalletMutation,
  useWalletControllerConnectWalletMutation,
  useTwitterControllerGetAuthorizeUrlQuery,
  useLazyTwitterControllerGetAuthorizeUrlQuery,
  useTwitterControllerAuthenticateMutation,
  useTwitterControllerConnectMutation,
  useTwitterControllerDisconnectMutation,
  useGoogleControllerAuthenticateMutation,
  useGoogleControllerGetAuthorizeUrlQuery,
  useLazyGoogleControllerGetAuthorizeUrlQuery,
  useGoogleControllerConnectMutation,
  useGoogleControllerDisconnectMutation,
  useGithubControllerAuthenticateMutation,
  useGithubControllerGetAuthorizeUrlQuery,
  useLazyGithubControllerGetAuthorizeUrlQuery,
  useGithubControllerConnectMutation,
  useGithubControllerDisconnectMutation,
  useTelegramControllerAuthenticateMutation,
  useTelegramControllerConnectMutation,
  useTelegramControllerDisconnectMutation,
  useDiscordControllerAuthenticateMutation,
  useDiscordControllerGetAuthorizeUrlQuery,
  useLazyDiscordControllerGetAuthorizeUrlQuery,
  useDiscordControllerConnectMutation,
  useDiscordControllerDisconnectMutation,
  useSteamControllerAuthenticateMutation,
  useSteamControllerGetAuthorizeUrlQuery,
  useLazySteamControllerGetAuthorizeUrlQuery,
  useSteamControllerConnectMutation,
  useSteamControllerDisconnectMutation,
  useRedditControllerAuthenticateMutation,
  useRedditControllerGetAuthorizeUrlQuery,
  useLazyRedditControllerGetAuthorizeUrlQuery,
  useRedditControllerConnectMutation,
  useRedditControllerDisconnectMutation,
  useSpotifyControllerAuthenticateMutation,
  useSpotifyControllerGetAuthorizeUrlQuery,
  useLazySpotifyControllerGetAuthorizeUrlQuery,
  useSpotifyControllerConnectMutation,
  useSpotifyControllerDisconnectMutation,
  useAppleControllerAuthenticateMutation,
  useAppleControllerConnectMutation,
  useAppleControllerDisconnectMutation,
  useCosmosControllerAuthenticateMutation,
  useCosmosControllerGetCosmosLoginMessageQuery,
  useLazyCosmosControllerGetCosmosLoginMessageQuery,
  useCosmosControllerDisconnectCosmosMutation,
  useCosmosControllerConnectWalletMutation,
  useVerificationControllerVerifyMutation,
  useVerificationControllerResendMutation,
  useAccountsControllerAddMutation,
  useAccountsControllerFindQuery,
  useLazyAccountsControllerFindQuery,
  useAccountsControllerUpdateMutation,
  useAccountsControllerRemoveMutation,
  useAccountsControllerAddEmailMutation,
  useAccountsControllerGetAccountsQuery,
  useLazyAccountsControllerGetAccountsQuery,
  useAccountsControllerVerifyAccountMutation,
  useAccountsControllerSetPrimaryMutation,
  useUsersControllerCreateMutation,
  useUsersControllerUpdateMutation,
  useUsersControllerRemoveMutation,
  useUsersControllerRoleChangeMutation,
  useUsersControllerChangePasswordMutation,
  useProfileControllerGetUserAvatarQuery,
  useLazyProfileControllerGetUserAvatarQuery,
  useProfileControllerUploadUserAvatarMutation,
  useProfileControllerGetUserDetailsWithCustomerQuery,
  useLazyProfileControllerGetUserDetailsWithCustomerQuery,
  useProfileControllerGetUserDetailsWithAdminQuery,
  useLazyProfileControllerGetUserDetailsWithAdminQuery,
  useProfileControllerAddXpMutation,
  useProfileControllerAddTicketMutation,
  useProfileControllerSearchQuery,
  useLazyProfileControllerSearchQuery,
  useProfileControllerFindAllQuery,
  useLazyProfileControllerFindAllQuery,
  useProfileControllerFindOneQuery,
  useLazyProfileControllerFindOneQuery,
  useFileControllerUploadUserAvatarMutation,
  useNotificationControllerCheckQuery,
  useLazyNotificationControllerCheckQuery,
  useNotificationControllerClearNotificationsMutation,
  useLeaderboardControllerInsertToLeaderboardMutation,
  useLeaderboardControllerGetLeaderBoardQuery,
  useLazyLeaderboardControllerGetLeaderBoardQuery,
  useClanControllerGetJoinRequestsQuery,
  useLazyClanControllerGetJoinRequestsQuery,
  useClanControllerCreateJoinRequestMutation,
  useClanControllerApproveJoinRequestMutation,
  useClanControllerRemoveJoinRequestMutation,
  useClanControllerChangeRoleMutation,
  useClanControllerRemoveMemberMutation,
  useClanControllerFindMembersQuery,
  useLazyClanControllerFindMembersQuery,
  useClanControllerUploadAvatarMutation,
  useClanControllerIsNameAvailableMutation,
  useClanControllerCreateMutation,
  useClanControllerFindAllQuery,
  useLazyClanControllerFindAllQuery,
  useClanControllerFindOneQuery,
  useLazyClanControllerFindOneQuery,
  useClanControllerUpdateMutation,
  useCustomerControllerFindAllWithStatsQuery,
  useLazyCustomerControllerFindAllWithStatsQuery,
  useCustomerControllerFindOneWithStatsQuery,
  useLazyCustomerControllerFindOneWithStatsQuery,
  useCustomerControllerAddBalanceMutation,
  useCustomerControllerUpdateAvatarMutation,
  useCustomerControllerGetAvatarQuery,
  useLazyCustomerControllerGetAvatarQuery,
  useCustomerControllerCreateMutation,
  useCustomerControllerFindAllQuery,
  useLazyCustomerControllerFindAllQuery,
  useCustomerControllerFindOneQuery,
  useLazyCustomerControllerFindOneQuery,
  useCustomerControllerUpdateMutation,
  useCustomerControllerDeleteMutation,
  useCustomerControllerSelfUpdateMutation,
  useHomeControllerGetInitQuery,
  useLazyHomeControllerGetInitQuery,
  useHomeControllerGetInitGuestQuery,
  useLazyHomeControllerGetInitGuestQuery,
  useHomeControllerGetSelfQuery,
  useLazyHomeControllerGetSelfQuery,
  useHomeControllerGetGuestHomeDataQuery,
  useLazyHomeControllerGetGuestHomeDataQuery,
  useHomeControllerGetUserHomeDataQuery,
  useLazyHomeControllerGetUserHomeDataQuery,
  useHomeControllerGetCompleteRatesQuery,
  useLazyHomeControllerGetCompleteRatesQuery,
  useTaskControllerFindTasksByFiltersQuery,
  useLazyTaskControllerFindTasksByFiltersQuery,
  useTaskControllerFindAmpTasksByFiltersQuery,
  useLazyTaskControllerFindAmpTasksByFiltersQuery,
  useTaskControllerFindCompletedAmpTasksByFiltersQuery,
  useLazyTaskControllerFindCompletedAmpTasksByFiltersQuery,
  useTaskControllerUpdateTaskSettingsMutation,
  useTaskControllerCreateMutation,
  useTaskControllerFindAllQuery,
  useLazyTaskControllerFindAllQuery,
  useTaskControllerFindPendingTaskQuery,
  useLazyTaskControllerFindPendingTaskQuery,
  useTaskControllerFindOneQuery,
  useLazyTaskControllerFindOneQuery,
  useTaskControllerUpdateMutation,
  useTaskControllerRemoveMutation,
  useTaskControllerVerifyTaskMutation,
  useTaskControllerApproveTaskMutation,
  useTaskControllerUnApproveTaskMutation,
  useTaskControllerJoinTaskMutation,
  useTaskControllerGetTaskParticipantDataQuery,
  useLazyTaskControllerGetTaskParticipantDataQuery,
  useTaskControllerPauseMutation,
  useTaskControllerActivateMutation,
  useTaskControllerFindParticipantsQuery,
  useLazyTaskControllerFindParticipantsQuery,
  useCampaignControllerUpdateRewardsMutation,
  useCampaignControllerFindAllParticipantsByIdQuery,
  useLazyCampaignControllerFindAllParticipantsByIdQuery,
  useCampaignControllerFindAllPublicParticipantsByIdQuery,
  useLazyCampaignControllerFindAllPublicParticipantsByIdQuery,
  useCampaignControllerFindAllWinnersByIdQuery,
  useLazyCampaignControllerFindAllWinnersByIdQuery,
  useCampaignControllerGetImageQuery,
  useLazyCampaignControllerGetImageQuery,
  useCampaignControllerUploadImageMutation,
  useCampaignControllerFindAllTasksQuery,
  useLazyCampaignControllerFindAllTasksQuery,
  useCampaignControllerUpsertTaskMutation,
  useCampaignControllerRemoveTaskMutation,
  useCampaignControllerVerifyCampaignMutation,
  useCampaignControllerPauseMutation,
  useCampaignControllerActivateMutation,
  useCampaignControllerWinnerMutation,
  useCampaignControllerFindAllPublicQuery,
  useLazyCampaignControllerFindAllPublicQuery,
  useCampaignControllerFindAllPublicWithAuthQuery,
  useLazyCampaignControllerFindAllPublicWithAuthQuery,
  useCampaignControllerFindAllGuestWithAuthQuery,
  useLazyCampaignControllerFindAllGuestWithAuthQuery,
  useCampaignControllerFindOnePublicQuery,
  useLazyCampaignControllerFindOnePublicQuery,
  useCampaignControllerFindOneGuestQuery,
  useLazyCampaignControllerFindOneGuestQuery,
  useCampaignControllerCreateMutation,
  useCampaignControllerFindAllQuery,
  useLazyCampaignControllerFindAllQuery,
  useCampaignControllerFindOneQuery,
  useLazyCampaignControllerFindOneQuery,
  useCampaignControllerUpdateMutation,
  useCampaignControllerRemoveMutation,
  useGiveawayControllerJoinMutation,
  useGiveawayControllerFindAllParticipantsByIdQuery,
  useLazyGiveawayControllerFindAllParticipantsByIdQuery,
  useGiveawayControllerFindAllWinnersByIdQuery,
  useLazyGiveawayControllerFindAllWinnersByIdQuery,
  useGiveawayControllerGetRewardsQuery,
  useLazyGiveawayControllerGetRewardsQuery,
  useGiveawayControllerSetWalletForRewardMutation,
  useGiveawayControllerCronJobsQuery,
  useLazyGiveawayControllerCronJobsQuery,
  useGiveawayControllerPauseMutation,
  useGiveawayControllerActivateMutation,
  useGiveawayControllerFindAllPublicQuery,
  useLazyGiveawayControllerFindAllPublicQuery,
  useGiveawayControllerCreateMutation,
  useGiveawayControllerFindAllQuery,
  useLazyGiveawayControllerFindAllQuery,
  useGiveawayControllerFindOneQuery,
  useLazyGiveawayControllerFindOneQuery,
  useGiveawayControllerUpdateMutation,
  useGiveawayControllerDeleteMutation,
  useDailyRewardControllerGetActiveCampaignStatusQuery,
  useLazyDailyRewardControllerGetActiveCampaignStatusQuery,
  useDailyRewardControllerClaimMutation,
  useDailyRewardControllerPauseMutation,
  useDailyRewardControllerActivateMutation,
  useDailyRewardControllerCreateMutation,
  useDailyRewardControllerFindAllQuery,
  useLazyDailyRewardControllerFindAllQuery,
  useDailyRewardControllerFindOneQuery,
  useLazyDailyRewardControllerFindOneQuery,
  useDailyRewardControllerUpdateMutation,
  useDailyRewardControllerDeleteMutation,
  useStatisticsControllerSummaryQuery,
  useLazyStatisticsControllerSummaryQuery,
  useStatisticsControllerSummaryPublicQuery,
  useLazyStatisticsControllerSummaryPublicQuery,
  useStatisticsControllerUserAcquisitionQuery,
  useLazyStatisticsControllerUserAcquisitionQuery,
  useStatisticsControllerTaskInteractionDataQuery,
  useLazyStatisticsControllerTaskInteractionDataQuery,
  useStatisticsControllerPointDistributionQuery,
  useLazyStatisticsControllerPointDistributionQuery,
  useStatisticsControllerUsersByLocationQuery,
  useLazyStatisticsControllerUsersByLocationQuery,
  useStatisticsControllerGetCustomerInfoQuery,
  useLazyStatisticsControllerGetCustomerInfoQuery,
  useStatisticsControllerGetStatsGoogleQuery,
  useLazyStatisticsControllerGetStatsGoogleQuery,
  useMidleTasksControllerIsAccountConnectedQuery,
  useLazyMidleTasksControllerIsAccountConnectedQuery,
  useMidleTasksControllerCheckRefCodeMutation,
} = injectedRtkApi;
